// front App.js

import React, { useState, useReducer, useContext, useEffect } from 'react';
import sha256 from 'crypto-js/sha256';
import { CSSTransition } from 'react-transition-group';
import './App.css';
import iconSignature from './signature.png';
import iconRevocation from './revocation.png';
import iconSwitchCertificant from './switchCertificant.png';
import iconMonaToMark from './starfish.png';
import iconImage from './outline_panorama_black_48dp.png';
import iconKey from './outline_vpn_key_black_18dp.png';
import iconTime from './outline_watch_later_black_18dp.png';
import iconRegister from './outline_done_black_24dp.png';
import iconDispenserBlack from './outline_point_of_sale_black_24dp.png';
import iconDispenserWhite from './outline_point_of_sale_white_24dp.png';
import iconVariety from './outline_interests_black_24dp.png';
import iconSend from './outline_send_black_24dp.png';
import iconHub from './outline_hub_black_24dp.png';
import iconInfo from './outline_info_black_24dp.png';
import iconArticle from './outline_article_black_24dp.png';
import iconClear from './outline_clear_all_black_18dp.png';
import Help from './Help.js';

const words = require('./words.json');

let GlobalState;

const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

// AppConnect対応

// porting nodejs EventEmitter
const EventEmitter=function(){function EventEmitter(){this._events=this._events||{};this._maxListeners=this._maxListeners||undefined}EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._maxListeners=undefined;EventEmitter.defaultMaxListeners=10;EventEmitter.prototype.setMaxListeners=function(n){if(!isNumber(n)||n<0||isNaN(n))throw TypeError("n must be a positive number");this._maxListeners=n;return this};EventEmitter.prototype.emit=function(type){var er,handler,len,args,i,listeners;if(!this._events)this._events={};if(type==="error"){if(!this._events.error||isObject(this._events.error)&&!this._events.error.length){er=arguments[1];if(er instanceof Error){throw er}else{var err=new Error('Uncaught, unspecified "error" event. ('+er+")");err.context=er;throw err}}}handler=this._events[type];if(isUndefined(handler))return false;if(isFunction(handler)){switch(arguments.length){case 1:handler.call(this);break;case 2:handler.call(this,arguments[1]);break;case 3:handler.call(this,arguments[1],arguments[2]);break;default:args=Array.prototype.slice.call(arguments,1);handler.apply(this,args)}}else if(isObject(handler)){args=Array.prototype.slice.call(arguments,1);listeners=handler.slice();len=listeners.length;for(i=0;i<len;i++)listeners[i].apply(this,args)}return true};EventEmitter.prototype.addListener=function(type,listener){var m;if(!isFunction(listener))throw TypeError("listener must be a function");if(!this._events)this._events={};if(this._events.newListener)this.emit("newListener",type,isFunction(listener.listener)?listener.listener:listener);if(!this._events[type])this._events[type]=listener;else if(isObject(this._events[type]))this._events[type].push(listener);else this._events[type]=[this._events[type],listener];if(isObject(this._events[type])&&!this._events[type].warned){if(!isUndefined(this._maxListeners)){m=this._maxListeners}else{m=EventEmitter.defaultMaxListeners}if(m&&m>0&&this._events[type].length>m){this._events[type].warned=true;console.error("(node) warning: possible EventEmitter memory "+"leak detected. %d listeners added. "+"Use emitter.setMaxListeners() to increase limit.",this._events[type].length);if(typeof console.trace==="function"){console.trace()}}}return this};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.once=function(type,listener){if(!isFunction(listener))throw TypeError("listener must be a function");var fired=false;function g(){this.removeListener(type,g);if(!fired){fired=true;listener.apply(this,arguments)}}g.listener=listener;this.on(type,g);return this};EventEmitter.prototype.removeListener=function(type,listener){var list,position,length,i;if(!isFunction(listener))throw TypeError("listener must be a function");if(!this._events||!this._events[type])return this;list=this._events[type];length=list.length;position=-1;if(list===listener||isFunction(list.listener)&&list.listener===listener){delete this._events[type];if(this._events.removeListener)this.emit("removeListener",type,listener)}else if(isObject(list)){for(i=length;i-- >0;){if(list[i]===listener||list[i].listener&&list[i].listener===listener){position=i;break}}if(position<0)return this;if(list.length===1){list.length=0;delete this._events[type]}else{list.splice(position,1)}if(this._events.removeListener)this.emit("removeListener",type,listener)}return this};EventEmitter.prototype.removeAllListeners=function(type){var key,listeners;if(!this._events)return this;if(!this._events.removeListener){if(arguments.length===0)this._events={};else if(this._events[type])delete this._events[type];return this}if(arguments.length===0){for(key in this._events){if(key==="removeListener")continue;this.removeAllListeners(key)}this.removeAllListeners("removeListener");this._events={};return this}listeners=this._events[type];if(isFunction(listeners)){this.removeListener(type,listeners)}else if(listeners){while(listeners.length)this.removeListener(type,listeners[listeners.length-1])}delete this._events[type];return this};EventEmitter.prototype.listeners=function(type){var ret;if(!this._events||!this._events[type])ret=[];else if(isFunction(this._events[type]))ret=[this._events[type]];else ret=this._events[type].slice();return ret};EventEmitter.prototype.listenerCount=function(type){if(this._events){var evlistener=this._events[type];if(isFunction(evlistener))return 1;else if(evlistener)return evlistener.length}return 0};EventEmitter.listenerCount=function(emitter,type){return emitter.listenerCount(type)};function isFunction(arg){return typeof arg==="function"}function isNumber(arg){return typeof arg==="number"}function isObject(arg){return typeof arg==="object"&&arg!==null}function isUndefined(arg){return arg===void 0}return EventEmitter}();
const ORIGIN = 'https://monapalette.komikikaku.com';
const SUPPORTED_METHODS = ['getAddress', 'sendAsset', 'signRawTransaction', 'signMessage', 'sendRawTransaction', 'counterBlock', 'counterParty'];
const monapaletteConnect = {};
const id2messageListener = {};
const sendMethod = async(method, params) => {
    if (!window.parent) throw new Error('AppConnect not found');
    const id = Math.random().toFixed(10).slice(-10);
    return await new Promise((resolve, reject) => {
        id2messageListener[id] = (event) => {
            try {
                if (event.origin !== ORIGIN) return;
                const data = event.data;
                if (data.id !== id) return;
                delete id2messageListener[id];
                if (data.error) reject(data.error);
                else resolve(data.value);
            }
            catch (error) { reject(error) }
        };
        window.parent.postMessage({ id, method, params }, ORIGIN);
    });
};
for (const method of SUPPORTED_METHODS) monapaletteConnect[method] = (...params) => sendMethod(method, params);
monapaletteConnect.updateEmitter = new EventEmitter();
window.monapaletteConnect = monapaletteConnect;
window.addEventListener('message', (event) => {
    for (const id in id2messageListener) id2messageListener[id](event);
});

// トップコンポーネント
function  App() {
  const urlParams = (new URL(document.location)).searchParams;

  const initialState = {
          screenMode: urlParams.get('screenMode') == null ? 'searchCertificateCore' : urlParams.get('screenMode'),
          searchPattern: urlParams.get('searchPattern') == null ? 'id' : urlParams.get('searchPattern'),
          searchNo: urlParams.get('no') == null ? '' : parseInt(urlParams.get('no'), 10),
          searchId: urlParams.get('id'),
          searchCommunity: urlParams.get('community'),
          searchCertificantAddress: urlParams.get('certificantAddress'),
          searchCertifierAddress: urlParams.get('certifierAddress'),
          certifierAddress: '',
          creationTimeClient: '',
          signature: '',
          revocationTimeClient: '',
          signatureForRevoke: '',
          onchainRevokeTXID: '',
          messageToSign: urlParams.get('messageToSign'),
          signatureOfMessage: '',
          addressForSignMessage: '',
          messageToVerify: urlParams.get('messageToVerify'),
          signatureToVerify: urlParams.get('signatureToVerify'),
          addressForVerify: urlParams.get('addressForVerify'),
          insertCertificateCertificantAddress: urlParams.get('insertCertificantAddress'),
          insertCertificateCommunity: urlParams.get('insertCommunity'),
          insertCertificateId: urlParams.get('insertId'),
          insertCreationTimeClient: urlParams.get('insertTime') === null ? '' : parseInt(urlParams.get('insertTime'), 10),
          insertCertificateSignature: urlParams.get('insertSignature'),
          displayRevoked: urlParams.get('displayRevoked') === 'true' ? true : false,
          certificateCores: [],
          certifiers: [],
          certifierHistories: [],
          insertCertifierDummy: [],
          insertCertificateDummy: [],
          revokeDummy: [],
          isVerified: undefined,
          addressToMarkString: urlParams.get('addressToMark'),
          addressToMark: [],
          addressTree: [],
          addressOfOwner: [],
//          addressOfIssuer: [],
          treeSteps: 3,
          targetCertificate: {},
          targetSignature: {},
          notification: { searchCertificateCore: '', certifier: '', insertCertificate: '', updateCertifier: '', signMessage: '',
                          verifySignature: '', setting: '' },
          notificationFade: { searchCertificateCore: false, certifier: false, insertCertificate: false, updateCertifier: false, signMessage: false,
                              verifySignature: false, setting: false },
          autoSearch: urlParams.get('autoSearch'),
          language: urlParams.get('language') === null ? 'japanese' : urlParams.get('language'),
          attachment: false,
          attachImagePopup: false,
          image: {
            type: 'MonaCharaT',
            id: '',
            registrationTimeClient: '',
            signature: '',
          },
          comfirmPopup: false,
          autoSearch2: {
            flag: false,
            trigger: false,
            deterNotification: false,
          },
          attachedInfoPopup: [],
          sendAssetPopup: [],
          sendAsset: {
            asset: 'MONA',
            amount: 0,
            memoType: 'no',
            memo: '',
          },
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  GlobalState = React.createContext([state, dispatch]);

  // 初期化
  useEffect( async () => {
    // 共通
    document.title = 'monatrust' + (process.env.REACT_APP_ENVIRONMENT === 'dev' ? ' dev' :  '');

    // AppConnect対応
    window.monapaletteConnect.getAddress().then(() => window.mpurse = window.monapaletteConnect).catch(() => {});
    
    // 保有トークン効果発動（いまは、language tokenに特化したif分になってる。）
    if (urlParams.get('language') === null && 'mpurse' in window) {
      checkTokensAndSet(false, state, dispatch);
    }

    if (window.opener && urlParams.get('inherit') === 'on') {
      // 設定引き継ぎ
      const addressToMarkString = window.opener.document.getElementById('addressToMarkString').value;
      dispatch({ type: 'setState', key: 'addressToMarkString', value: addressToMarkString });
      dispatch({ type: 'setState', key: 'addressToMark', value: splitIntoLines(addressToMarkString) }); 

      const treeSteps = window.opener.document.getElementById('treeSteps').value;
      devLog('inh', treeSteps);
      dispatch({ type: 'setState', key: 'treeSteps', value: parseInt(treeSteps, 10) });

      const addressTree = window.opener.document.getElementById('addressTree').value;
      devLog('inh', addressTree);
      dispatch({ type: 'setState', key: 'addressTree', value: JSON.parse(addressTree) });

      const addressOfOwner = window.opener.document.getElementById('addressOfOwner').value;
      devLog('inh', addressOfOwner);
      dispatch({ type: 'setState', key: 'addressOfOwner', value: JSON.parse(addressOfOwner) });
    }
    else {
      // 引き継ぎなし
      let request = {};
      request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_master';
      const messages = {
//            "success": 'Insert done.'
      };
      request.body = JSON.stringify({"body": {"key" : 'treeSteps'}});
      const response = await syncHttpRequest(request);
      devLog(JSON.stringify(response));
      const body = JSON.parse(response.body.body);
      devLog(body.value);

      dispatch({ type: 'setState', key: 'treeSteps', value: body.value });
      dispatch({ type: 'setState', key: 'addressTree', value: Array(body.value + 1).fill([]) });
    }
  }, [])

  useEffect( () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [state.screenMode])

  useEffect( () => {
    // -- オートサーチ
    if (state.autoSearch2.flag) {
      HandleClickSearch(state, dispatch, state.autoSearch2.deterNotification);
    }
  }, [state.autoSearch2.trigger])

  // オートサーチ
  if (state.autoSearch === 'on') {
    HandleClickSearch(state, dispatch);
    dispatch({type: 'setState', key: 'autoSearch', value: 'off' });
  }

  if (state.screenMode === 'searchCertificateCore') { // 証明書検索画面
    return (
      <SearchCertificateCore className='body' />
    );
  }
  else if (state.screenMode === 'certifier') { // 署名表示画面
    return (
      <Certifier />
    );
  }
  else if (state.screenMode === 'insertCertificate') { // 証明書作成画面
    return (
      <InsertCertificate />
    );
  }
  else if (state.screenMode === 'updateCertifier') { // 署名更新画面
    return (
      <UpdateCertifier />
    );
  }
  else if (state.screenMode === 'signMessage') { // メッセージ署名画面
    return (
      <SignMessage />
    );
  }
  else if (state.screenMode === 'verifySignature') { // 署名検証画面
    return (
      <VerifySignature />
    );
  }
  else if (state.screenMode === 'setting') { // 設定画面
    return (
      <Setting />
     );
  }
  else if (state.screenMode === 'help') { // ヘルプ画面
    return (
      <Help />
     );
  }
}

// 証明書検索画面(searchCertificateCore)
function SearchCertificateCore() {
  const [state, dispatch] = useContext(GlobalState);
  const searchPatterns = [{value: 'scan', face: words.all[state.language]}, {value: 'no', face: words.number[state.language]}, {value: 'id', face: words.id[state.language]},
                          {value: 'community', face: words.community[state.language]}, {value: 'community_id', face: words.community_id[state.language]},
                          {value: 'certificantAddress', face: words.certificantAddress[state.language] }, {value: 'certifierAddress', face: words.certifierAddress[state.language]}];

  return (
    <div className="App">
      <div className="header">
        <TitleMenu />
        <div className='titleMenuPadding' />
        <div className='flexRowSpColumn ' >
          <div className='input'> {/* search */}
            <div className='flexRowSpColumn marginSp02'>
              <div>{ words.searchPattern[state.language]}</div>
              <Select block={searchPatterns} value={state.searchPattern} onChange={ (e) => dispatch({type: 'setState', key: 'searchPattern', value: e.target.value}) } />
            </div>
            {/* scanのときは何も表示しない */}
            { state.searchPattern === 'no' &&
              <Search label={words.number[state.language]} content={state.searchNo} onChange={ (e) => dispatch({type: 'setStateNum', key: 'searchNo', value: e.target.value}) } /> }
            { state.searchPattern === 'id' &&
              <Search label={words.id[state.language]} content={state.searchId} onChange={ (e) => dispatch({type: 'setState', key: 'searchId', value: e.target.value}) } /> }
            { state.searchPattern === 'community' &&
              <Search label={words.community[state.language]} content={state.searchCommunity}
              onChange={ (e) => dispatch({type: 'setState', key: 'searchCommunity', value: e.target.value}) } /> }
            { state.searchPattern === 'community_id' &&
              <div>
                <Search label={words.community[state.language]} labelStyle='insertLabel' content={state.searchCommunity}
                onChange={ (e) => dispatch({type: 'setState', key: 'searchCommunity', value: e.target.value}) } />
                <Search label={words.id[state.language]} labelStyle='insertLabel' content={state.searchId}
                onChange={ (e) => dispatch({type: 'setState', key: 'searchId', value: e.target.value}) } />
              </div> }
            { state.searchPattern === 'certificantAddress' &&
              <div className='flexRowSpColumn alignItemsStretch'>
                <Search label={words.address[state.language]} content={state.searchCertificantAddress}
                onChange={ (e) => dispatch({type: 'setState', key: 'searchCertificantAddress', value: e.target.value}) } />
                <Button face='mpurse'
                onClick={ () => GetAddress( (address) => dispatch({ type: 'setState', key: 'searchCertificantAddress', value: address }) ) } />
              </div> }
            { state.searchPattern === 'certifierAddress' &&
              <div className='flexRowSpColumn alignItemsStretch'>
                <Search label={words.address[state.language]} content={state.searchCertifierAddress}
                onChange={ (e) => dispatch({type: 'setState', key: 'searchCertifierAddress', value: e.target.value}) } />
                <Button face='mpurse'
                onClick={ () => GetAddress( (address) => dispatch({ type: 'setState', key: 'searchCertifierAddress', value: address }) ) } />
              </div> }
            <div className='flexRowSpColumn baseline'>
              <div className='revokedCheckBox' /> {/* パディング */}
              <Button face={words.search[state.language]} onClick={ () => HandleClickSearch(state, dispatch) } />
              <Button face={words.clear[state.language]} onClick={ () => handleClickClearSearch(state, dispatch) } />
              <ToggleRevoked />
            </div>
          </div>
          <div className='input' >
            <button className='buttonBack focusEffect01' onClick={ () => dispatch({ type: 'setState', key: 'attachment', value: !state.attachment }) } >
              <img className='twoEm' src={iconVariety} />
            </button>
          </div>
        </div>
      </div>
      <div className='notification'> {/* notification area */}
        <CSSTransition in={state.notificationFade.searchCertificateCore} timeout={5000} classNames="messageFade"
          onEntered={ () => {
                        dispatch({ type: 'unsetNotification', key: 'searchCertificateCore' });
                      }
                    }
        >
          <div>{state.notification.searchCertificateCore}</div>
        </CSSTransition>
      </div>
      <div>
        <CertificateCoreTable />
      </div>
    </div>
  );
}

/*
            <label for='PUCB_mainMenu' className='focusEffect01' tabindex='0' onKeyUp={(e) => {
              if (e.key === ' ' || e.key === 'Enter') {
                document.getElementById("PUCB_mainMenu").checked=true;
              }
            }}>
              menu
            </label>

                <label for='PUCB_mainMenu' onKeyUp={(e) => {
                  if (e.key === ' ' || e.key === 'Enter') {
                    document.getElementById("PUCB_mainMenu").checked=false;
                  }
                }}>
                  <div className='focusEffect01 rightText' tabindex="0">x</div>
                </label>
*/

// 署名画面(certifier)
function Certifier() {
  const [state, dispatch] = useContext(GlobalState);
  let jsxArray;

  return (
    <div className="App">
      <div className="header">
        <TitleMenu />
        <div className='titleMenuPadding' />
        <div className='paddingTopSp2' />
        <div className='flexRowSpColumn alignItemsCenter widthSp100'>
          <div className='flexRowSpColumn alignItemsStretch widthSp90 '>
            <div className={ state.targetCertificate.revocationTime ? 'boxTargetCertificateRevoked' : 'box2' }> {/* コア */}
              <div className='no'>{state.targetCertificate.no}</div>
              <div className='leftText'>
                <div className='addressSmall flexRow'>
                  {state.targetCertificate.certificantAddress}
                </div>
                  {state.targetCertificate.community}<br/>
                  {state.targetCertificate.id}
                <div className='fontSize2'>
                  { new Date(state.targetCertificate.creationTimeClient).toLocaleString() }
                  { state.targetCertificate.revocationTimeClient && ' - ' + new Date(state.targetCertificate.revocationTimeClient).toLocaleString()}
                </div>
              </div>
              <div className='addressSmall flexColumn'>
                { jsxArray = [...Array(state.treeSteps + 1).keys()].map( i => state.addressTree[i].includes(state.targetCertificate.certificantAddress) ?
                  <div className='relative'>
                    <img className='monaEm' src={iconMonaToMark} />
                    <span className='treeNumber'>{i}</span>
                  </div>
                  : null ) }
                { state.addressOfOwner.includes(state.targetCertificate.certificantAddress) ?
                  <div className='relative'>
                    <img className='monaEm' src={iconMonaToMark} />
                    <span className='treeNumber'>W</span>
                  </div>
                  : null }
                { state.addressToMark.includes(state.targetCertificate.certificantAddress) ?
                  <img className='monaEm' src={iconMonaToMark} /> : <div className='monaEm' /> }
              </div>
            </div>
            <BackButton screenMode='searchCertificateCore' focusEffect='focusEffect01' />
            <AttachImagePopupButton  focusEffect='focusEffect01' />
            <AttachImagePopup />
          </div>
          <div className='input'> {/* 入力 */}
            <div className=''>
              {words.address[state.language]}
              <input className='textfield1 widthSp100 font1Sp08' type='text' value={state.certifierAddress}
                onChange={ (e) => dispatch({ type: 'setState', key: 'certifierAddress', value: e.target.value}) } />
              <Button face='mpurse' onClick={ () => GetAddress( (address) => dispatch({ type: 'setState', key: 'certifierAddress', value: address }) ) } />
            </div>
            <div className=''>
              {words.time[state.language]}
              <input className='textfield1 widthSp100 font1Sp08' type='text' value={state.creationTimeClient}
                onChange={ (e) => dispatch({ type: 'setStateNum', key: 'creationTimeClient', value: e.target.value}) } />
              <Button face={words.now[state.language]} onClick={ () => dispatch({ type: 'setStateNum', key: 'creationTimeClient', value: Date.now() }) } />
            </div>
            <div className=''>
              {words.signature[state.language]}
              <input className='textfield1 widthSp100 font1Sp08' type='text' value={state.signature}
                onChange={ (e) => dispatch({ type: 'setState', key: 'signature', value: e.target.value}) } />
              <Button face='mpurse' onClick={ () => {
                                      Sign(
                                            sha256(
                                                      'monatrust:1:certify,' +
                                                      state.targetCertificate.certificantAddress + ',' +
                                                      state.targetCertificate.community + ',' +
                                                      state.targetCertificate.id + ',' +
                                                      state.creationTimeClient
                                            ).toString(),
                                            (signature) => dispatch({ type: 'setState', key: 'signature', value: signature})
                                      );
                                    }}
              />
            </div>
            <div className='flexRowSpColumn'>
              <PopupComfirm face={words.sign[state.language]} onClick={ () => HandleClickInsertCertifier(state, dispatch) } />
              <div><Button face={words.clear[state.language]} onClick={ () => handleClickClearSign(state, dispatch) } /></div>
              <ToggleRevoked />
            </div>
          </div>
        </div>
      </div>
      <div className='notification'> {/* notification area */}
        <CSSTransition in={state.notificationFade.certifier} timeout={5000} classNames="messageFade"
          onEntered={ () => {
                        dispatch({ type: 'unsetNotification', key: 'certifier' });
                      }
                    }
        >
          <div>{state.notification.certifier}</div>
        </CSSTransition>
      </div>
      <div>
        <CertifierTable />
      </div> {/* inherit */}
      <textarea id='addressToMarkString' className='noDisplay' value={state.addressToMarkString} />
      <textarea id='treeSteps' className='noDisplay' value={state.treeSteps} />
      <textarea id='addressTree' className='noDisplay' value={JSON.stringify(state.addressTree)} />
      <textarea id='addressOfOwner' className='noDisplay' value={JSON.stringify(state.addressOfOwner)} />
    </div>
  );
}

// 証明書作成画面
function InsertCertificate () {
  const [state, dispatch] = useContext(GlobalState);

  return (
    <div className="App">
      <div className="header noBottom">
        <TitleMenu />
      </div>
      <div className='titleMenuPadding' />
      {/* notification area */}
        <CSSTransition in={state.notificationFade.insertCertificate} timeout={5000} classNames="messageFade"
          onEntered={ () => {
                        dispatch({ type: 'unsetNotification', key: 'insertCertificate' });
                      }
                    }
        >
          <div>{state.notification.insertCertificate}</div>
        </CSSTransition>
      <div className='alignCenter widthSp100 font1Sp2'>
        <div className='insertInput'> {/* input */}
          <div className='flexRowSpColumn'>
            <div className='insertLabel'>
              {words.address[state.language]}
            </div>
            <input className='textfield1 font1Sp08' type='text' value={state.insertCertificateCertificantAddress}
              onChange={ (e) => dispatch({ type: 'setState', key: 'insertCertificateCertificantAddress', value: e.target.value}) } />
            <Button face='mpurse' onClick={ () => GetAddress( (address) =>
                                                    dispatch({ type: 'setState', key: 'insertCertificateCertificantAddress', value: address }) ) } />
          </div>
          <div className='flexRowSpColumn'>
            <div className='insertLabel'>
              {words.community[state.language]}
            </div>
            <input className='textfield1 font1Sp08' type='text' value={state.insertCertificateCommunity}
              onChange={ (e) => dispatch({ type: 'setState', key: 'insertCertificateCommunity', value: e.target.value}) } />
          </div>
          <div className='flexRowSpColumn'>
            <div className='insertLabel'>
              {words.id[state.language]}
            </div>
            <input className='textfield1 font1Sp08' type='text' value={state.insertCertificateId}
              onChange={ (e) => dispatch({ type: 'setState', key: 'insertCertificateId', value: e.target.value}) } />
          </div>
          <div className='flexRowSpColumn'>
            <div className='insertLabel'>
              {words.time[state.language]}
            </div>
            <input className='textfield1 font1Sp08' type='text' value={state.insertCreationTimeClient}
              onChange={ (e) => dispatch({ type: 'setStateNum', key: 'insertCreationTimeClient', value: e.target.value}) } />
            <Button face={words.now[state.language]} onClick={ () => dispatch({ type: 'setStateNum', key: 'insertCreationTimeClient', value: Date.now() }) } />
          </div>
          <div className='flexRowSpColumn'>
            <div className='insertLabel'>
              {words.signature[state.language]}
            </div>
            <input className='textfield1 font1Sp08' type='text' value={state.insertCertificateSignature}
              onChange={ (e) => dispatch({ type: 'setState', key: 'insertCertificateSignature', value: e.target.value}) } />
            <Button face='mpurse' onClick={ () => Sign(
                                                    sha256(
                                                      'monatrust:1:certify,' +
                                                      state.insertCertificateCertificantAddress + ',' +
                                                      state.insertCertificateCommunity + ',' +
                                                      state.insertCertificateId + ',' +
                                                      state.insertCreationTimeClient
                                                    ).toString(),
                                                    (signature) => dispatch({ type: 'setState', key: 'insertCertificateSignature', value: signature })
                                                  )
                                  } 
            />
          </div>
        </div>
        <div className='flexRowSpColumn widthSp90'> {/* button */}
          <PopupComfirm face={words.sign[state.language]} onClick={ () => HandleClickInsertCertificate(state, dispatch) } />
          <div><Button face={words.clear[state.language]} onClick={ () => handleClickClearCertificate(state, dispatch) } /></div>
        </div>
      </div>
    </div>
  );
} 

// 署名更新画面(revoke)
function UpdateCertifier() {
  const [state, dispatch] = useContext(GlobalState);
  let jsxArray;

  return (
    <div className="App">
      <div className="header">
        <TitleMenu />
        <div className='titleMenuPadding' />
        <div className='paddingTopSp2' />
        <div className='flexRowSpColumn alignItemsCenter widthSp100'>
            <div className='flexRowSpColumn widthSp90'>
              <div className={ state.targetCertificate.revocationTime ? 'boxTargetCertificateRevoked' : 'box2' }> {/* target certificate */}
                <div className='no'>{state.targetCertificate.no}</div>
                <div className='leftText'>
                  <div className='addressSmall flexRow'>
                    {state.targetCertificate.certificantAddress}
                  </div>
                  <div>
                    {state.targetCertificate.community}<br/>
                    {state.targetCertificate.id}
                  </div>
                  <div className='fontSize2'>
                    { new Date(state.targetCertificate.creationTimeClient).toLocaleString() }
                    { state.targetCertificate.revocationTimeClient && ' - ' + new Date(state.targetCertificate.revocationTimeClient).toLocaleString()}
                  </div>
                </div>
                <div className='addressSmall flexColumn'>
                  { jsxArray = [...Array(state.treeSteps + 1).keys()].map( i => state.addressTree[i].includes(state.targetCertificate.certificantAddress) ?
                    <div className='relative'>
                      <img className='monaEm' src={iconMonaToMark} />
                      <span className='treeNumber'>{i}</span>
                    </div>
                    : null ) }
                  { state.addressOfOwner.includes(state.targetCertificate.certificantAddress) ?
                    <div className='relative'>
                      <img className='monaEm' src={iconMonaToMark} />
                      <span className='treeNumber'>W</span>
                    </div>
                    : null }
                  { state.addressToMark.includes(state.targetCertificate.certificantAddress) ?
                    <img className='monaEm' src={iconMonaToMark} /> : <div className='monaEm' /> }
                </div>
              </div>
              <div className={ state.targetSignature.signatureOfRevocation ? 'boxSignatureRevoked' : 'box1' }> {/* target signature */}
                <div className='flexColumn'>
                  <div className='addressBig flexRow'>
                    {state.targetSignature.certifierAddress}
                  </div>
                  <div className='flexRow'>
                    <PopupSignature record={state.targetSignature} />
                    {state.targetSignature.signatureOfRevocation ? <PopupSignatureOfRevocation record={state.targetSignature} /> : null}
                    <SearchCertifierInNewWindow record={state.targetSignature} />
                  </div>
                </div>
                <div className='addressSmall flexColumn'>
                  { jsxArray = [...Array(state.treeSteps + 1).keys()].map( i => state.addressTree[i].includes(state.targetSignature.certifierAddress) ?
                    <div className='relative'>
                      <img className='monaEm' src={iconMonaToMark} />
                      <span className='treeNumber'>{i}</span>
                    </div>
                    : null ) }
                  { state.addressOfOwner.includes(state.targetSignature.certifierAddress) ?
                    <div className='relative'>
                      <img className='monaEm' src={iconMonaToMark} />
                      <span className='treeNumber'>W</span>
                    </div>
                    : null }
                  { state.addressToMark.includes(state.targetSignature.certifierAddress) ?
                    <img className='monaEm' src={iconMonaToMark} /> : <div className='monaEm' /> }
                </div>
              </div>
              <BackButton screenMode='certifier' focusEffect='focusEffect01' />
            </div>
          <div className='input'> {/* input signature */}
            <div>
              {words.time[state.language]}
              <input className='textfield1 widthSp100 font1Sp08' type='text' value={state.revocationTimeClient}
                onChange={ (e) => dispatch({ type: 'setStateNum', key: 'revocationTimeClient', value: e.target.value}) } />
              <Button face={words.now[state.language]} onClick={ () => dispatch({ type: 'setStateNum', key: 'revocationTimeClient', value: Date.now() }) } />
            </div>
            <div>
              {words.signature[state.language]}
              <input className='textfield1 widthSp100 font1Sp08' type='text' value={state.signatureForRevoke}
                onChange={ (e) => dispatch({ type: 'setState', key: 'signatureForRevoke', value: e.target.value}) } />
              <Button face='mpurse' onClick={ () => Sign( 
                                                      sha256(
                                                        'monatrust:1:revoke,' +
                                                        state.targetCertificate.certificantAddress + ',' +
                                                        state.targetCertificate.community + ',' +
                                                        state.targetCertificate.id + ',' +
                                                        state.revocationTimeClient
                                                      ).toString(),
                                                      (signature) => dispatch({ type: 'setState', key: 'signatureForRevoke', value: signature})
                                                    )
                                    }
              />
            </div>
            <div>
              {words.txid[state.language]}
              <input className={ (state.targetSignature.signatureOfRevocation ? 'textfield1' : 'textfield1Disabled') + ' widthSp100 font1Sp08' } type='text' value={state.onchainRevokeTXID}
                disabled={ state.targetSignature.signatureOfRevocation ? false : true } onChange={ (e) => dispatch({ type: 'setState', key: 'onchainRevokeTXID', value: e.target.value}) } />
            </div>
            <div className='flexRowSpColumn'>
              <PopupComfirm face={words.sign[state.language]} onClick={ () => handleClickRevokeSign(state, dispatch) } />
              <div><Button face={words.onchain[state.language]} onClick={ () => handleClickOnchainRevoke(state, dispatch) } /></div>
              <PopupComfirm face={words.setTxid[state.language]} disabled={state.targetSignature.signatureOfRevocation ? false : true} PUCBIdSuffix='_setTXID'
                onClick={ () => HandleClickSetTXID(state, dispatch) } />
              <div><Button face={words.clear[state.language]} onClick={ () => handleClickClearRevokeSignature(state, dispatch) } /></div>
            </div>
          </div>
        </div>
      </div>
      <div className='notification'> {/* notification area */}
        <CSSTransition in={state.notificationFade.updateCertifier} timeout={5000} classNames="messageFade"
          onEntered={ () => {
                        dispatch({ type: 'unsetNotification', key: 'updateCertifier' });
                      }
                    }
        >
          <div>{state.notification.updateCertifier}</div>
        </CSSTransition>
      </div>
      <div>
        <CertifierHistoryTable />
      </div>
      <textarea id='addressToMarkString' className='noDisplay' value={state.addressToMarkString} />
      <textarea id='treeSteps' className='noDisplay' value={state.treeSteps} />
      <textarea id='addressTree' className='noDisplay' value={JSON.stringify(state.addressTree)} />
    </div>

  );
}

// メッセージ署名画面
function SignMessage() {
  const [state, dispatch] = useContext(GlobalState);

  return (
    <div className="App">
      <div className="header noBottom">
        <TitleMenu />
      </div>
      <div className='titleMenuPadding' />
      {/* notification area */}
        <CSSTransition in={state.notificationFade.signMessage} timeout={5000} classNames="messageFade"
          onEntered={ () => {
                        dispatch({ type: 'unsetNotification', key: 'signMessage' });
                      }
                    }
        >
          <div>{state.notification.signMessage}</div>
        </CSSTransition>
      <div className='alignCenter font1Sp2'>
        <div className='width60Sp90 leftText'> {/* message */}
          {words.message[state.language]}
        </div>
        <textarea id='messageToSign' className='messageArea width60Sp90 font1Sp06' value={state.messageToSign}
          onChange={ (e) => dispatch({ type: 'setState', key: 'messageToSign', value: e.target.value }) } />
        <div className='width60Sp90'> {/* button */}
          <Button face={words.sign[state.language]} onClick={ () => { Sign( 
                                                                        state.messageToSign,
                                                                        (signature) => dispatch({ type: 'setState', key: 'signatureOfMessage', value: signature})
                                                                      );
                                                                      GetAddress( (address) => dispatch({ type: 'setState', key: 'addressForSignMessage', value: address }) );
                                                              }
                                                    }
          />
          <Button face={words.copy[state.language]} onClick={ () => copyClipboard("--message begin--\n" + state.messageToSign + "\n--message end--\n--address--\n" +
                                                                      state.addressForSignMessage + "\n--signature--\n" + state.signatureOfMessage) } />
          <Button face={words.clear[state.language]} onClick={ () => handleClickClearMessage(state, dispatch) } />
        </div>
        <div className='width60Sp90 leftText'> {/* signature */}
          {words.signature[state.language]}
        </div>
        <textarea className='width60Sp90 height20 monoFont font1Sp06' value={state.signatureOfMessage} />
      </div>
      <div className='alignCenter'>
        <div className='insertInput'>
        </div>
      </div>
    </div>

  );
}

// 署名検証画面
function VerifySignature() {
  const [state, dispatch] = useContext(GlobalState);

  return (
    <div className="App">
      <div className="header noBottom">
        <TitleMenu />
      </div>
      <div className='titleMenuPadding' />
      {/* notification area */}
        <CSSTransition in={state.notificationFade.verifySignature} timeout={5000} classNames="messageFade"
          onEntered={ () => {
                        dispatch({ type: 'unsetNotification', key: 'verifySignature' });
                      }
                    }
        >
          <div>{state.notification.verifySignature}</div>
        </CSSTransition>
      <div className='alignCenter font1Sp2'>
        <div className='leftText width60Sp90'> {/* message */}
          {words.message[state.language]}
        </div>
        <textarea className='messageArea width60Sp90 font1Sp06' value={state.messageToVerify}
          onChange={ (e) => dispatch({ type: 'setState', key: 'messageToVerify', value: e.target.value }) } />
        <div className='insertInput'>
          <div className='flexRowSpColumn'> {/* address */}
            <div className='insertLabel'>
              {words.address[state.language]}
            </div>
            <input className='textfield1 font1Sp06' type='text' value={state.addressForVerify}
              onChange={ (e) => dispatch({ type: 'setState', key: 'addressForVerify', value: e.target.value}) } />
          </div>
          <div className='flexRowSpColumn'> {/* signature */}
            <div className='insertLabel'>
              {words.signature[state.language]}
            </div>
            <input className='textfield1 font1Sp06' type='text' value={state.signatureToVerify}
              onChange={ (e) => dispatch({ type: 'setState', key: 'signatureToVerify', value: e.target.value}) } />
          </div>
        </div>
        <div className='flexRowSpColumn widthSp90'> {/* button */}
          <Button face={words.paste[state.language]} onClick={ () => pasteClipboard(dispatch) } />
          <Button face={words.verify[state.language]} onClick={ () => handleClickVerifySignature(state, dispatch) } />
          <Button face={words.clear[state.language]} onClick={ () => handleClickClearVerifySignature(state, dispatch) } />
        </div>
        {/* state.isVerified !== undefined && state.isVerified.toString() */}
      </div>
    </div>

  );
}

// 設定画面
function Setting() {
  const [state, dispatch] = useContext(GlobalState);

  return (
    <div className="App">
      <div className="header noBottom">
        <TitleMenu />
      </div>
      <div className='titleMenuPadding' />
      {/* notification area */}
        <CSSTransition in={state.notificationFade.setting} timeout={5000} classNames="messageFade"
          onEntered={ () => {
                        dispatch({ type: 'unsetNotification', key: 'setting' });
                      }
                    }
        >
          <div>{state.notification.setting}</div>
        </CSSTransition>
      <div className='alignCenter font1Sp2'>
        <div className='width60Sp90 leftText marginTop1p5'> {/* tree */}
          {words.markAsTreeFromYourAddress[state.language]} ({state.treeSteps}{words.steps[state.language]})
          <Button face={words.set[state.language]} onClick={ () => {handleClickTreeMarking(state, dispatch)} } />
          <Button face={words.clear[state.language]} onClick={ () => handleClickClearTreeMarking(state, dispatch) } />
{/*
          <div className='addressSmall'>{state.addressTree[0]}</div>
          <div className='addressSmall'>{state.addressTree[1]}</div>
          <div className='addressSmall'>{state.addressTree[2]}</div>
*/}
        </div>
        <div className='width60Sp90 leftText marginTop1p5'> {/* arbitary */}
          {words.addressToMark[state.language]}
        </div>
        <textarea id='addressToMarkString' className='messageArea width60Sp90' value={state.addressToMarkString}
          onChange={ (e) => dispatch({ type: 'setState', key: 'addressToMarkString', value: e.target.value }) } />
        <div className='flexRowSpColumn widthSp90'>
          <Button face={words.set[state.language]} onClick={ () => handleClickSetAddressToMark(state, dispatch) } />
          <Button face={words.clear[state.language]} onClick={ () => handleClickClearAddressToMark(state, dispatch) } />
        </div>
        <div className='width60Sp90 leftText marginTop1p5'> {/* token owner */}
          {words.monapartyTokenOwnersAddress[state.language]}
          <Button face={words.set[state.language]} onClick={ () => {
            if ('mpurse' in window) {
              handleClickTokenOwnerMarking(state, dispatch);
            }
            else {
             dispatch({ type: 'setNotification', key: 'setting',  value: words.mpurseIsNotActivated[state.language] });
            }
          }} />
          <Button face={words.clear[state.language]} onClick={ () => handleClickClearTokenOwnerMarking(state, dispatch) } />
        </div>
        {/* <div>{state.addressOfOwner}</div> */}
        {/* <div>{state.addressOfIssuer}</div> */}
        <div className='width60Sp90 leftText marginTop1p5'> {/* token owner */}
          {words.reloadYourMonapartyTokens[state.language]}
          <Button face={words.reload[state.language]} onClick={ () => {
            if ('mpurse' in window) {
              checkTokensAndSet(true, state, dispatch)
            }
            else {
             dispatch({ type: 'setNotification', key: 'setting',  value: words.mpurseIsNotActivated[state.language] });
            }
          }} />
        </div>
      </div>
    </div>

  );

}

// 証明書コアテーブル
function CertificateCoreTable(props) {
  const [state, dispatch] = useContext(GlobalState);
  let filteredCertificateCores;

  if (state.displayRevoked) {
    filteredCertificateCores = state.certificateCores;
  }
  else {
    filteredCertificateCores = state.certificateCores.filter( (element) => {return (!element.revocationTime)} );
  }
  
  const records = filteredCertificateCores.map((record) =>
    <li><Record record={record} onClick={props.onClick} /></li>
  );
  return (
    <ul className='container'>
      {records}
    </ul>
  );
}

// 証明書コアレコード
function Record(props) {
  const [state, dispatch] = useContext(GlobalState);
  let jsxArray;
  devLog('treeSteps', state.treeSteps);

  return (
       <div className={ props.record.revocationTime ? 'boxCertificateRevoked' : 'boxCertificateCore' }>
         <div className={ props.record.revocationTime ? 'boxCertificateRevokedInnerTop' : 'boxCertificateCoreInnerTop' }>
           <div className='no'>
             {props.record.no}
           </div>
           <div className='leftText'>
             <div className='addressSmall flexRow'>
               {props.record.certificantAddress}
             </div>
             <div>
               {props.record.community}<br/>
               {props.record.id}
             </div>
             <div className='fontSize2'>
               {new Date(props.record.creationTimeClient).toLocaleString()}
               { props.record.revocationTimeClient && ' - ' + new Date(props.record.revocationTimeClient).toLocaleString()}
             </div>
           </div>
           <div className='addressSmall flexColumn'>
             { jsxArray = [...Array(state.treeSteps + 1).keys()].map( i => state.addressTree[i].includes(props.record.certificantAddress) ?
               <div className='relative'>
                 <img className='monaEm' src={iconMonaToMark} />
                 <span className='treeNumber'>{i}</span>
               </div>
               : null ) }
             { state.addressOfOwner.includes(props.record.certificantAddress) ?
               <div className='relative'>
                 <img className='monaEm' src={iconMonaToMark} />
                 <span className='treeNumber'>W</span>
               </div>
               : null }
             { state.addressToMark.includes(props.record.certificantAddress) ?
               <img className='monaEm' src={iconMonaToMark} /> : <div className='monaEm' /> }
           </div>
         </div>
         { state.attachment ? <Attachment record={props.record} /> : null }
         <div className={'cornerBorder bottomRight ' + ( props.record.revocationTime ? 'focusEffectRevoked' : ' focusEffect02' )} tabindex='0'
           onClick={ () => handleClickLook(state, dispatch, props.record)}
           onKeyUp={ (e) => {
               if (e.key === 'Enter') {
                 handleClickLook(state, dispatch, props.record)
               }
           }}
         >
           >>
         </div>
       </div>
  );
}

//               { jsxArray.every( value => value === null ) ? <div className='monaEm' /> : null }

// アタッチメント
function Attachment(props) {
  const [state, dispatch] = useContext(GlobalState);

  return (
    <div className='flexRowSpColumn justifyCenter' >
        <div className='flexColumn'>
          <div className='flexRow alignItemsFlexEnd'>
            { props.record.image !== undefined && props.record.image.type !== undefined ?
                <button className='button2 focusEffect02 flexColumn justifyCenter alignItemsCenter' tabindex='0'
                  onClick={() => window.open('https://monacharat.komikikaku.com/' + props.record.image.id)}
                >
                  <img className='attachedImage' src={`https://monacharat-img.komikikaku.com/${props.record.image.id}_320.png`} />
                </button> :
                <img className='attachedImage' src={iconImage} />
            }
            <div className='flexColumn'>
              <button className='button2 focusEffect02 flexColumn justifyCenter alignItemsCenter' tabindex='0'
                onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['attachedInfoPopup', props.record.no], value: true }) }
              >
                <img className='oneFiveEm' src={iconInfo} />
              </button>
              <AttachedInfoPopup record={props.record} />
              <button className='button2 focusEffect02 flexColumn justifyCenter alignItemsCenter ' tabindex='0'
                onClick={ () => dispatch({ type: 'setCertifierAddressAndSearch', certifierAddress: props.record.certificantAddress, deterNotification: false }) }
              >
                <img className='oneFiveEm' src={iconHub} />
              </button>
              <button className='button2 focusEffect02 flexColumn justifyCenter alignItemsCenter ' tabindex='0'
                onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['sendAssetPopup', props.record.no], value: true }) }
              >
                <img className='oneFiveEm' src={iconSend} />
              </button>
              <SendAssetPopup record={props.record} />
            </div>
            <div className='flexColumn'>
              <button className='button2 focusEffect02 flexColumn justifyCenter alignItemsCenter ' tabindex='0'
                onClick={() => window.open('https://monapalette.komikikaku.com/dispensers?search=' + props.record.certificantAddress)}
              >
                <img className='oneFiveEm' src={iconDispenserBlack} />
              </button>
              <button className='button2 focusEffect02 flexColumn justifyCenter alignItemsCenter ' tabindex='0'
                onClick={() => window.open('https://www.mona-tools.com/mona_dispenser_open.php?addr_to=' + props.record.certificantAddress)}
              >
                <img className='oneFiveEm' src={iconDispenserWhite} />
              </button>
              <button className='button2 focusEffect02 flexColumn justifyCenter alignItemsCenter ' tabindex='0'
                onClick={() => window.open('https://monaledge.com/user/' + props.record.certificantAddress)}
              >
                <img className='oneFiveEm' src={iconArticle} />
              </button>
            </div>
          </div>
          { props.record.image !== undefined && props.record.image.type !== undefined ?
              <div className='flexColumn'>
                <div className='fontSize0p7'>
                  {words[props.record.image.type][state.language]}
                </div>
                <div className='addressSmall'>
                  {props.record.image.id}
                </div>
                <div className='fontSize0p7'>
                  {props.record.image.description.substr(8)}
                </div>
              </div> :
              <div className='flexColumn'>
                <div className='fontSize0p7'>
                  no image
                </div>
                <div className='addressSmall'>
                  {'　'}
                </div>
                <div className='fontSize0p7'>
                  {'　'}
                </div>
              </div>
          }
        </div>
    </div>
  );
}

// 署名テーブル
function CertifierTable() {
  const [state, dispatch] = useContext(GlobalState);
  let filteredCertifiers;
  let jsxArray;

  if (state.displayRevoked) {
    filteredCertifiers = state.certifiers;
  }
  else {
    filteredCertifiers = state.certifiers.filter( (element) => {return (!element.signatureOfRevocation)} );
  }

  const records = filteredCertifiers.map( (record) =>
    <li>
      <div className={ record.signatureOfRevocation ? 'boxSignatureRevoked' : 'box1' }>
        <div className='flexColumn'>
          <div className='leftText addressBig flexRow'>
            <div>{record.certifierAddress}</div>
          </div>
          <div className='flexRow'>
            <PopupSignature record={record} />
            {record.signatureOfRevocation ? <PopupSignatureOfRevocation record={record} /> : null}
            <SearchCertifierInNewWindow record={record}/>
          </div>
        </div>
        <div className='addressSmall flexColumn between'>
          <div className=''>
          { jsxArray = [...Array(state.treeSteps + 1).keys()].map( i => state.addressTree[i].includes(record.certifierAddress) ?
            <div className='relative'>
              <img className='monaEm' src={iconMonaToMark} />
              <span className='treeNumber'>{i}</span>
            </div>
            : null ) }
          { state.addressOfOwner.includes(record.certifierAddress) ?
            <div className='relative'>
              <img className='monaEm' src={iconMonaToMark} />
              <span className='treeNumber'>W</span>
            </div>
            : null }
          { state.addressToMark.includes(record.certifierAddress) ?
            <img className='monaEm' src={iconMonaToMark} /> : <div className='monaEm' /> }
          </div>
        </div>
        <div className={'cornerBorder bottomRight ' + ( record.signatureOfRevocation ? 'focusEffectRevoked' : ' focusEffectCertifier' )} tabindex='0'
          onClick={ () => handleClickRevoke(state, dispatch, record) }
          onKeyUp={ (e) => {
            if (e.key === 'Enter') {
              handleClickRevoke(state, dispatch, record)
            }
          }}
        >
          >>
        </div>
      </div>
    </li>
  );
  return (
    <ul className='container'>
      {records}
    </ul>
  );
}

// 署名履歴テーブル
function CertifierHistoryTable() {
  const [state, dispatch] = useContext(GlobalState);

  const records = state.certifierHistories.map( (record) =>
    <li>
      <div className='boxSignatureRevoked'>
        <div className='flexRow'>
          <PopupSignatureHistory record={record} />
          <PopupSignatureOfRevocationHistory record={record} />
        </div>
      </div>
    </li>
  );

  return (
    <ul className='container'>
      {records}
    </ul>
  );
}

// ボタン
function Button(props) {
  return (
    <button className={'button1 focusEffect01 margin0302 marginSpSide0' + ( props.disabled ? ' disabled' : ' transparent' )} value={props.value}
      disabled={props.disabled ? true : false} onClick={props.onClick}>
      {props.face}
    </button>
  );
}

// 検索キーボックス
function Search(props) {
  return (
    <div className='flexRowSpColumn marginSp02'>
      <div className={props.labelStyle}>{props.label}</div>
      <input className='textfield1 widthSp100 font1Sp08' type="text" value={props.content} onChange={props.onChange} />
    </div>
  );
}

// 選択メニュー
function Select(props) {
  const options = props.block.map( (option) =>
    <Option option={option} />
  );
  return (
    <select className='selectbox1 focusEffect01' name="" value={props.value} onChange={props.onChange}>
      {options}
    </select>
  );
}

// 選択肢
function Option(props) {
  return (
    <option value={props.option.value}>{props.option.face}</option>
  );
}

// OPTIONS BLESS
function optionsBless(array) {
  return array.map( (element) => <Option option={element} /> );
}

// 選択肢 BLESS
function OptionBless(props) {
  return (
    <option value={props.option.value}>{props.option.face}</option>
  );
}

// MAIN MENU
function MainMenu() {
  const [state, dispatch] = useContext(GlobalState);
  return (
        <div className='mainMenu'>
          <div className='flexRow justifyEnd'>
            <button className='button0 focusEffect01' tabindex="0" onClick={ () => document.getElementById("PUCB_mainMenu").checked=true } >
              {words.menu[state.language]}
            </button>
          </div>
          <input className='popUpCheckBox' id='PUCB_mainMenu' type='checkbox' />
          <div className='popUpRight'>
            <label for='PUCB_mainMenu' className='closePopUp' />
            <div className='popUpMenu font1Sp2'>
              <div className='width100 flexRow justifyEnd'>
                <button className='button0 focusEffect01' tabindex="0" onClick={ () => document.getElementById("PUCB_mainMenu").checked=false } >
                  x
                </button>
              </div>
              <div>
                <button className='button0 focusEffect01 leftText' tabindex="0" onClick={ () => {
                  if (state.screenMode === 'searchCertificateCore') {
                    document.getElementById("PUCB_mainMenu").checked=false;
                  }
                  else {
                    dispatch({type: 'setScreenMode', value: 'searchCertificateCore'});
                  }
                }}>
                  {words.searchMode[state.language]}
                </button>
              </div>
              <div>
                <button className='button0 focusEffect01 leftText' tabindex="0" onClick={ () => {
                  if (state.screenMode === 'insertCertificate') {
                    document.getElementById("PUCB_mainMenu").checked=false;
                  }
                  else {
                    dispatch({type: 'setScreenMode', value: 'insertCertificate'});
                  }
                }}>
                  {words.insertMode[state.language]}
                </button>
              </div>
              <div>
                <button className='button0 focusEffect01 leftText' tabindex='0' onClick={ () => {
                  if (state.screenMode === 'signMessage') {
                    document.getElementById("PUCB_mainMenu").checked=false;
                  }
                  else {
                    dispatch({type: 'setScreenMode', value: 'signMessage'});
                  }
                }}>
                  {words.signMessageMode[state.language]}
                </button>
              </div>
              <div>
                <button className='button0 focusEffect01 leftText' tabindex='0' onClick={ () => {

                  if (state.screenMode === 'verifySignature') {
                    document.getElementById("PUCB_mainMenu").checked=false;
                  }
                  else {
                    dispatch({type: 'setScreenMode', value: 'verifySignature'});
                  }
                }}>
                  {words.verifySignatureMode[state.language]}
                </button>
              </div>
              <div>
                <button className='button0 focusEffect01 leftText' tabindex='0' onClick={ () => {
                  if (state.screenMode === 'setting') {
                    document.getElementById("PUCB_mainMenu").checked=false;
                  }
                  else {
                    dispatch({type: 'setScreenMode', value: 'setting'});
                  }
                }}>
                  {words.settingMode[state.language]}
                </button>
              </div>
                <button className='button0 focusEffect01 leftText' tabindex='0' onClick={ () => {
                  if (state.screenMode === 'help') {
                    document.getElementById("PUCB_mainMenu").checked=false;
                  }
                  else {
                    document.getElementById("PUCB_mainMenu").checked=false;
                    window.open('https://' + process.env.REACT_APP_DOMAIN_STATIC + '?screenMode=help', '_blank');
                  }
                }}>
                  {words.helpMode[state.language]}
                </button>
              <div>
              </div>
            </div>
          </div>
        </div>
  );
}

// TITLE & MENUE
function TitleMenu () {
  const [state, dispatch] = useContext(GlobalState);

  return (
    <div className='flexRow width100 justifyBetween titleMenu heightSp3'>
      <div className='title font1Sp2'>
        monatrust
        {process.env.REACT_APP_ENVIRONMENT === 'dev' ? ' dev' :  ''}
      </div>
      <div className='flexRow' >
        <div className='marginSide0p5'>
          <button className={'borderNone backgroundColorBimyonaWhite focusEffect01 ' + (state.language === 'english' ? 'colorRed' : '')} tabindex='0'
            onClick={ () => {
                      dispatch({type: 'setState', key: 'language', value: 'english'});
            }}>
            english
          </button>
          <button className={'borderNone backgroundColorBimyonaWhite focusEffect01 ' + (state.language === 'japanese' ? 'colorRed' : '')} tabindex='0'
            onClick={ () => {
                      dispatch({type: 'setState', key: 'language', value: 'japanese'});
            }}>
            japanese
          </button>
        </div>
        <MainMenu />
      </div>
    </div>
  );
}

// POPUP SIGNATURE
function PopupSignature (props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <button className={'button2 ' + ( props.record.signatureOfRevocation ? 'focusEffectRevoked' : 'focusEffectCertifier')} tabindex="0"
               onClick={ () => document.getElementById('PUCB_sig_' + props.record.certifierAddress).checked=true } >
               <img className='twoEm' src={iconSignature} />
             </button>
             <input className='popUpCheckBox' id={'PUCB_sig_' + props.record.certifierAddress} type='checkbox' />
             <div className='popUp'>
               <label className='closePopUp' for={'PUCB_sig_' + props.record.certifierAddress} />
               <div className='popUpWrap textCenter'>
                 <button className='topRight focusEffect01' tabindex='0'
                   onClick={ () => document.getElementById('PUCB_sig_' + props.record.certifierAddress).checked=false } >
                   x
                 </button>
                 {props.record.signatureOfCore} <br/>
                 {words.client[state.language] + ': ' + new Date(props.record.creationTimeClient).toLocaleString() + ' ' +  props.record.creationTimeClient} <br/>
                 {words.server[state.language] + ': ' + new Date(props.record.creationTime).toLocaleString() + ' ' +  props.record.creationTime}
               </div>
             </div>
           </div>
  );
}

// POPUP SIGNATURE OF REVOCATION
function PopupSignatureOfRevocation (props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <button className='button2 focusEffectRevoked' tabindex="0"
               onClick={ () => document.getElementById('PUCB_rev_' + props.record.certifierAddress).checked=true } >
               <img className='twoEm' src={iconRevocation} />
             </button>
             <input className='popUpCheckBox' id={'PUCB_rev_' + props.record.certifierAddress} type='checkbox' />
             <div className='popUp'>
               <label className='closePopUp' for={'PUCB_rev_' + props.record.certifierAddress} />
               <div className='popUpWrap textCenter'>
                 <button className='topRight focusEffect01' tabindex='0'
                   onClick={ () => document.getElementById('PUCB_rev_' + props.record.certifierAddress).checked=false } >
                   x
                 </button>
                 {props.record.signatureOfRevocation} <br/>
                 {'onchainRevokeTXID: ' + props.record.onchainRevokeTXID} <br/>
                 {words.client[state.language] + ': ' + new Date(props.record.revocationTimeClient).toLocaleString() + ' ' + props.record.revocationTimeClient} <br/>
                 {words.server[state.language] + ': ' + new Date(props.record.revocationTime).toLocaleString() + ' ' + props.record.revocationTime}
               </div>
             </div>
           </div>
  );
}

/*
// POPUP SIGNATURE HEADER
function PopupSignatureHeader () {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <button className={'button2 ' + ( state.targetSignature.signatureOfRevocation ? 'focusEffectRevoked' : 'focusEffectCertifier')} tabindex="0"
               onClick={ () => document.getElementById('PUCB_sig_update').checked=true } >
               <img className='twoEm' src={iconSignature} />
             </button>
             <input className='popUpCheckBox' id={'PUCB_sig_update'} type='checkbox' />
             <div className='popUp'>
               <label className='closePopUp' for={'PUCB_sig_update'} />
               <div className='popUpWrap textCenter'>
                 <button className='topRight focusEffect01' tabindex='0'
                   onClick={ () => document.getElementById('PUCB_sig_update').checked=false } >
                   x
                 </button>
                 {state.targetSignature.signatureOfCore} <br/> {new Date(state.targetSignature.creationTime).toLocaleString()}
               </div>
             </div>
           </div>
  );
}

// POPUP SIGNATURE OF REVOCATION HEADER
function PopupSignatureOfRevocationHeader () {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <button className='button2 focusEffectRevoked' tabindex="0"
               onClick={ () => document.getElementById('PUCB_rev_update').checked=true } >
               <img className='twoEm' src={iconRevocation} />
             </button>
             <input className='popUpCheckBox' id={'PUCB_rev_update'} type='checkbox' />
             <div className='popUp'>
               <label className='closePopUp' for={'PUCB_rev_update'} />
               <div className='popUpWrap textCenter'>
                 <button className='topRight focusEffect01' tabindex='0'
                   onClick={ () => document.getElementById('PUCB_rev_update').checked=false } >
                   x
                 </button>
                 {state.targetSignature.signatureOfRevocation} <br/> {new Date(state.targetSignature.revocationTime).toLocaleString()}
               </div>
             </div>
           </div>
  );
}
*/

// POPUP SIGNATURE HISTORY
function PopupSignatureHistory (props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <button className='button2 focusEffectRevoked' tabindex="0"
               onClick={ () => document.getElementById('PUCB_sig_' + props.record.historyNumber).checked=true } >
               <img className='twoEm' src={iconSignature} />
             </button>
             <input className='popUpCheckBox' id={'PUCB_sig_' + props.record.historyNumber} type='checkbox' />
             <div className='popUp'>
               <label className='closePopUp' for={'PUCB_sig_' + props.record.historyNumber} />
               <div className='popUpWrap'>
                 <button className='topRight focusEffect01' tabindex='0'
                   onClick={ () => document.getElementById('PUCB_sig_' + props.record.historyNumber).checked=false } >
                   x
                 </button>
                 {props.record.signatureOfCore} <br/>
                 {words.client[state.language] + ': ' + new Date(props.record.creationTimeClient).toLocaleString() + ' ' +  props.record.creationTimeClient} <br/>
                 {words.server[state.language] + ': ' + new Date(props.record.creationTime).toLocaleString() + ' ' +  props.record.creationTime}
               </div>
             </div>
           </div>
  );
}

// POPUP SIGNATURE OF REVOCATION HISTORY
function PopupSignatureOfRevocationHistory (props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <button className='button2 focusEffectRevoked' tabindex="0"
               onClick={ () => document.getElementById('PUCB_rev_' + props.record.historyNumber).checked=true } >
               <img className='twoEm' src={iconRevocation} />
             </button>
             <input className='popUpCheckBox' id={'PUCB_rev_' + props.record.historyNumber} type='checkbox' />
             <div className='popUp'>
               <label className='closePopUp' for={'PUCB_rev_' + props.record.historyNumber} />
               <div className='popUpWrap'>
                 <button className='topRight focusEffect01' tabindex='0'
                   onClick={ () => document.getElementById('PUCB_rev_' + props.record.historyNumber).checked=false } >
                   x
                 </button>
                 {props.record.signatureOfRevocation} <br/>
                 {'onchainRevokeTXID: ' + props.record.onchainRevokeTXID} <br/>
                 {words.client[state.language] + ': ' + new Date(props.record.revocationTimeClient).toLocaleString() + ' ' + props.record.revocationTimeClient} <br/>
                 {words.server[state.language] + ': ' + new Date(props.record.revocationTime).toLocaleString() + ' ' + props.record.revocationTime}
               </div>
             </div>
           </div>
  );
}

// POPUP COMFIRM
function PopupComfirm (props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <Button face={props.face} disabled={props.disabled} onClick={ () => {document.getElementById('PUCB_comfirm' + props.PUCBIdSuffix).checked=true} } />
             <input className='popUpCheckBox' id={'PUCB_comfirm' + props.PUCBIdSuffix} type='checkbox' />
             <div className='popUp'>
               <label className='closePopUp' for={'PUCB_comfirm' + props.PUCBIdSuffix} />
               <div className='popUpWrap textCenter'>
                 <div>{words.areYouSure[state.language]}</div>
                 <div>
                   <Button face={words.yes[state.language]} onClick={ () => {
                     document.getElementById('PUCB_comfirm' + props.PUCBIdSuffix).checked=false;
                     props.onClick();
                   }}/>
                   <Button face={words.no[state.language]} onClick={ () => {
                     document.getElementById('PUCB_comfirm' + props.PUCBIdSuffix).checked=false;
                   }}/>
                 </div>
               </div>
             </div>
           </div>
  );
}

// COMFIRM POPUP
function ComfirmPopup (props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <button className='buttonBless2' disabled={props.disabled ? true : false} onClick={ () => { dispatch({type: 'setState', key: 'comfirmPopup', value: true}) } }>
               <img className='size2x2' src={props.img} /><br/>
               {props.face}
             </button>
             <div className={'popup2 ' + ( state.comfirmPopup === false ? 'invisible' : '' )} >
               <button className='closePopUp' onClick={ () => { dispatch({type: 'setState', key: 'comfirmPopup', value: false}) } } />
               <div className='popUpWrap textCenter'>
                 <div>{props.message}</div>
                 <div>
                   <button className='buttonBless2' onClick={ () => {
                     dispatch({type: 'setState', key: 'comfirmPopup', value: false});
                     props.onClick();
                   }}>
                     {words.yes[state.language]}
                   </button>
                   <button className='buttonBless2' onClick={ () => {
                     dispatch({type: 'setState', key: 'comfirmPopup', value: false});
                   }}>
                     {words.no[state.language]}
                   </button>
                 </div>
               </div>
             </div>
           </div>
  );
}

// SEARCH CERTIFIER IN NEW WINDOW
function SearchCertifierInNewWindow (props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
           <div>
             <button
               className={'button2 ' + ( props.record.signatureOfRevocation ? 'focusEffectRevoked' : ' focusEffectCertifier' )} tabindex='0'
               onClick={() => window.open('https://' + process.env.REACT_APP_DOMAIN_STATIC + '?certificantAddress=' + props.record.certifierAddress +
                                          '&searchPattern=certificantAddress&autoSearch=on&displayRevoked=' + state.displayRevoked + '&inherit=on', '_blank')} >
               <img className='twoEm' src={iconSwitchCertificant} />
             </button>
           </div>
  )
}

// TOGGLE REVOKED
function ToggleRevoked () {
  const [state, dispatch] = useContext(GlobalState);
  return (
    <div>
      <button className={(state.displayRevoked ? 'checkOn' : 'checkOff') + ' focusEffectBorder'} onClick={ () => dispatch({ type: 'toggle', key: 'displayRevoked' }) } />
      <button className={(state.displayRevoked ? 'checkOnString' : 'checkOffString') + ' focusEffect01'} onClick={ () => dispatch({ type: 'toggle', key: 'displayRevoked' }) }>
        {words.revoked[state.language]}
      </button>
    </div>
  );
}

// BACK BUTTON
function BackButton (props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
    <div className={ 'buttonBack ' + props.focusEffect } tabindex='0' onClick={ () => dispatch({ type: 'setScreenMode', value: props.screenMode }) }
      onKeyUp={(e) => {
        if (e.key === 'Enter') {
          dispatch({ type: 'setScreenMode', value: props.screenMode })
        }
      }}
    >
      {'<<'}
    </div>
  );
}

// ATTACH IMAGE POPUP BUTTON
function AttachImagePopupButton(props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
    <div className={ 'flexColumn justifyCenter alignItemsCenter attachedImage2Outer ' + props.focusEffect } tabindex='0'
      onClick={ () => dispatch({ type: 'setState', key: 'attachImagePopup', value: true }) }
      onKeyUp={(e) => {
        if (e.key === 'Enter') {
          dispatch({ type: 'setState', key: 'attachImagePopup', value: true })
        }
      }}
    >
        { state.targetCertificate.image !== undefined && state.targetCertificate.image.type !== undefined ?
            <img className='attachedImage2' src={`https://monacharat-img.komikikaku.com/${state.targetCertificate.image.id}_320.png`} /> :
            <img className='attachedImage2' src={iconImage} />
        }
    </div>
  );
}

// ATTACH IMAGE POPUP
function AttachImagePopup(props) {
  const [state, dispatch] = useContext(GlobalState);
  const imageTypes = [ {value: 'MonaCharaT', face: words.MonaCharaT[state.language]}, {value: 'detach', face: words.detach[state.language]} ];

  return (
      <div className={ 'popup' + state.attachImagePopup } >
        <button className='closePopUp' onClick={ () => dispatch({ type: 'setState', key: 'attachImagePopup', value: false }) } />
        <div className={ 'popUpWrap2 textCenter' }>
          <button className='topRightClose focusEffect01' tabindex='0'
            onClick={ () => dispatch({ type: 'setState', key: 'attachImagePopup', value: false }) } >
            x
          </button>
          <div className='flexColumn alignItemsFlexStart marginTop1'>
            <div className='textLeft fontSize0p7'>
              {words.imageType[state.language]}
            </div>
            <select className='selectboxBless1 widthWithButton1NarrowSp ' name="" value={state.image.type}
              onChange={ (e) => dispatch({type: 'setStateMultiLayers', keys: ['image', 'type'], value: e.target.value}) }>
              {optionsBless(imageTypes)}
            </select>
          </div>
          <div className='flexRow justifyContentFlexStart marginTop1 '>
            <TextLine2 fieldName='imageId' keys={['image', 'id']} face={words.MonaCharaTId[state.language]} />
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1'>
            <TextLine2 fieldName='imageRegistrationTimeClient' keys={['image', 'registrationTimeClient']} type='setStateMultiLayersNum'
              face={words.time[state.language]} />
            <button className='buttonBless1'
              onClick={ () => dispatch({ type: 'setStateMultiLayersNum', keys: ['image', 'registrationTimeClient'], value: Date.now() }) }>
              <img className='size2x2' src={iconTime} />
            </button>
          </div>
          <TextAreaUneditable fieldName='imageRegistrationLocalTimeClient' face={words.localTime[state.language]} boxClass='boxBless1 widthWithButton1NarrowSp'
            textAreaClass='textArea2' value={ localTime(state.image.registrationTimeClient) } /> 
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTopBottom1'>
            <TextLine2 fieldName='imageSignature' keys={['image', 'signature']} face={words.signature[state.language]} />
            <button className='buttonBless1' onClick={ () => Sign(
                                                               messageToSignFunc(state, { action: 'attachImage' }),
                                                               (signature) => dispatch({ type: 'setStateMultiLayers', keys: ['image', 'signature'], value: signature})
                                             ) }
            >
              <img className='size2x2' src={iconKey} />
            </button>
          </div>
          <div className='flexRow justifyCenter marginTop1'>
            <ComfirmPopup face={words.set[state.language]} img={iconRegister} message={words.areYouSure[state.language]}
              onClick={ () => handleClickRegisterImage(state, dispatch) } />
            <button className='buttonBless2' onClick={ () => handleClickClearAttachImage(dispatch) }>
              <img className='size2x2' src={iconClear} /><br/>
              {words.clear[state.language]}
            </button>
          </div>
        </div>
      </div>
  );
}

// TEXT LINE MULTI LAYERS STATE
function TextLine2(props) {
  const [state, dispatch] = useContext(GlobalState);
  const value = props.keys.reduce( (acc, cur) => { return acc[cur]; }, state );
  const type = props.type !== undefined ? props.type : 'setStateMultiLayers';

  return (
    <div>
            <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Background'} type='checkbox' />
            <div className='boxBless1 widthWithButton1NarrowSp'>
              <input className='textLine1' type="text" value={value} placeholder=''
                onFocus={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=true; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=true; 
                }}
                onBlur={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=false; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=false; 
                }}
                onChange={ (e) => {
                  dispatch({type: type, keys: props.keys, value: e.target.value});
              }} />
              <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Label'} type='checkbox' />
              <div className={ value === '' ? 'label1Unfilled' : 'label1Filled'}>
                {props.face}
              </div>
            </div>
    </div>
  );
}

// TEXT AREA UNEDITABLE
function TextAreaUneditable(props) {
  const [state, dispatch] = useContext(GlobalState);
  return (
    <div>
            <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Background'} type='checkbox' />
            <div className={props.boxClass}>
              <textarea className={props.textAreaClass} id={'TAUE_' + props.fieldName} value={props.value}
                onFocus={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=true; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=true; 
                }}
                onBlur={ () => {
                  document.getElementById('UVCB_' + props.fieldName + 'Background').checked=false; 
                  document.getElementById('UVCB_' + props.fieldName + 'Label').checked=false; 
                }}
              />
              <input className='invisibleCheckBox' id={'UVCB_' + props.fieldName + 'Label'} type='checkbox' />
              <div className='label1Filled'>
                {props.face}
              </div>
            </div>
    </div>
  );
}

// ATTACHED INFO POPUP
function AttachedInfoPopup(props) {
  const [state, dispatch] = useContext(GlobalState);

  return (
      <div className={ 'popup' + state.attachedInfoPopup[props.record.no] } >
        <button className='closePopUp' onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['attachedInfoPopup', props.record.no], value: false }) } />
        <div className={ 'popUpWrap2 textCenter' }>
          <button className='topRightClose focusEffect01' tabindex='0'
            onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['attachedInfoPopup', props.record.no], value: false }) } >
            x
          </button>
          <TextAreaUneditable fieldName='attachedInfoImageType' face={words.imageType[state.language]} boxClass='box4 width90Sp' textAreaClass='textArea2'
            value={ props.record.image !== undefined ? props.record.image.type || '' : '' } /> 
          <TextAreaUneditable fieldName='attachedInfoId' face={words.id[state.language]} boxClass='box4 width90Sp' textAreaClass='textArea2'
            value={ props.record.image !== undefined ? props.record.image.id || '' : '' } /> 
          <TextAreaUneditable fieldName='attachedInfoDescription' face={words.description[state.language]} boxClass='box4 width90Sp' textAreaClass='textArea2'
            value={ props.record.image !== undefined ? props.record.image.description || '' : '' } /> 
          <TextAreaUneditable fieldName='attachedInfoRegistrationTimeClient' face={words.registrationTimeClient[state.language]} boxClass='box4 width90Sp' textAreaClass='textArea2'
            value={ props.record.image !== undefined ? props.record.image.registrationTimeClient + ' | ' + localTime(props.record.image.registrationTimeClient) || '' : '' } /> 
          <TextAreaUneditable fieldName='attachedInfoRegistrationTimeServer' face={words.registrationTimeServer[state.language]} boxClass='box4 width90Sp' textAreaClass='textArea2'
            value={ props.record.image !== undefined ? props.record.image.registrationTime + ' | ' + localTime(props.record.image.registrationTime) || '' : '' } /> 
          <TextAreaUneditable fieldName='attachedInfoSignature' face={words.signature[state.language]} boxClass='box4 width90Sp' textAreaClass='textArea2'
            value={ props.record.image !== undefined ? props.record.image.signature || '' : '' } /> 
        </div>
      </div>
  );
}

// SEND ASSET POPUP
function SendAssetPopup(props) {
  const [state, dispatch] = useContext(GlobalState);
  const memoType = [ {value: 'no', face: words.noMemo[state.language]}, {value: 'plain', face: words.text[state.language]},
                       {value: 'hex', face: words.hex[state.language]} ];

  return (
      <div className={ 'popup' + state.sendAssetPopup[props.record.no] } >
        <button className='closePopUp' onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['sendAssetPopup', props.record.no], value: false }) } />
        <div className={ 'popUpWrap2 textCenter' }>
          <button className='topRightClose focusEffect01' tabindex='0'
            onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['sendAssetPopup', props.record.no], value: false }) }
          >
            x
          </button>
          <div className='flexRow justifyContentFlexStart marginTop1 '>
            <TextLine2 fieldName='sendAssetAsset' keys={['sendAsset', 'asset']} face={words.asset[state.language]} />
          </div>
          <div className='flexRow justifyContentFlexStart marginTop1 '>
            <TextLine2 fieldName='sendAssetAmount' keys={['sendAsset', 'amount']} face={words.amount[state.language]} />
          </div>
          { state.sendAsset.asset !== 'MONA' &&
              <div>
                <div className='flexColumn alignItemsFlexStart marginTop1'>
                  <div className='textLeft fontSize0p7'>
                    {words.memoType[state.language]}
                  </div>
                  <select className='selectboxBless1 widthWithButton1NarrowSp ' value={state.sendAsset.memoType}
                    onChange={ (e) => dispatch({type: 'setStateMultiLayers', keys: ['sendAsset', 'memoType'], value: e.target.value}) }>
                    {optionsBless(memoType)}
                  </select>
                </div>
                { state.sendAsset.memoType !== 'no' &&
                  <div className='flexRow justifyContentFlexStart marginTop1 '>
                    <TextLine2 fieldName='sendAssetMemo' keys={['sendAsset', 'memo']} face={words.memo[state.language]} />
                  </div>
                }
              </div>
          }
          <button className='buttonBless2'
              onClick={ () => {
                window.mpurse.sendAsset(props.record.certificantAddress, state.sendAsset.asset, state.sendAsset.amount,
                                        state.sendAsset.memoType, state.sendAsset.memo)
                  .then( (result) => {
                    dispatch({ type: 'setNotification', key: 'searchCertificateCore',  value: words.success[state.language] });
                    dispatch({ type: 'setStateMultiLayers', keys: ['sendAssetPopup', props.record.no], value: false });
                  })
                  .catch( (error) => {
                    dispatch({ type: 'setNotification', key: 'searchCertificateCore',  value: words.somehowFailed[state.language] });
                  })
              }}
          >
            <img className='size2x2' src={iconRegister} /><br/>
            {words.send[state.language]}
          </button>
        </div>
      </div>
  );
}

// 検索ボタン押下処理
async function HandleClickSearch(state, dispatch, deterNotification) {
  let request = {};
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_certificate_core';
  const messages = {
    "success": words.success[state.language],
    "internal server error": words.internalServerError[state.language],
    "unknown select key": words.unknownSelectKey[state.language],
    "success, but the 'no' does not exist.": words.successButTheNoDoesNotExist[state.language],
    "success, but the id(& community) does not exist.": words.successButTheIdAndCommunityDoesNotExist[state.language],
    "success, but the certificantAddress does not exist.": words.successButTheCertificantAddressDoesNotExist[state.language],
    "success, but the community does not exist.": words.successButTheCommunityDoesNotExist[state.language],
    "success, but the certifierAddress does not exist.": words.successButTheCertifierAddressDoesNotExist[state.language],
  };

  const sortFunction = (a, b) => a.no - b.no;

  if (state.searchPattern === 'no') {
    if (state.searchNo === '' || state.searchNo === null) {
      dispatch({ type: 'setNotification', key: 'searchCertificateCore',  value: words.noFieldMustBeFilledIn[state.language] });
      return;
    }

    request.body = JSON.stringify({"body": {"no" : state.searchNo}});
  }
  else if (state.searchPattern === 'id') {
    if (state.searchId === '' || state.searchId === null) {
      dispatch({ type: 'setNotification', key: 'searchCertificateCore',  value: words.idFieldMustBeFilledIn[state.language] });
      return;
    }

    request.body = JSON.stringify({"body": {"id" : state.searchId}});
  }
  else if (state.searchPattern === 'certificantAddress') {
    if (state.searchCertificantAddress === '' || state.searchCertificantAddress === null) {
      dispatch({ type: 'setNotification', key: 'searchCertificateCore',  value: words.certificantAddressFieldMustBeFilledIn[state.language] });
      return;
    }

    request.body = JSON.stringify({"body": {"certificantAddress" : state.searchCertificantAddress}});
  }
  else if (state.searchPattern === 'community') {
    if (state.searchCommunity === '' || state.searchCommunity === null) {
      dispatch({ type: 'setNotification', key: 'searchCertificateCore',  value: words.communityFieldMustBeFilledIn[state.language] });
      return;
    }

    request.body = JSON.stringify({"body": {"community" : state.searchCommunity}});
  }
  else if (state.searchPattern === 'community_id') {
    if (state.searchCommunity === '' || state.searchCommunity === null || state.searchId === '' || state.searchId === null) {
      dispatch({ type: 'setNotification', key: 'searchCertificateCore',  value: words.communityAndIdFieldsMustBeFilledIn[state.language] });
      return;
    }

    request.body = JSON.stringify({"body": {"community" : state.searchCommunity, "id" : state.searchId}});
  }
  else if (state.searchPattern === 'certifierAddress') {
    if (state.searchCertifierAddress === '' || state.searchCertifierAddress === null) {
      dispatch({ type: 'setNotification', key: 'searchCertificateCore',  value: words.certifierAddressFieldMustBeFilledIn[state.language] });
      return;
    }

    request.body = JSON.stringify({"body": {"certifierAddress" : state.searchCertifierAddress}});
  }
  else if (state.searchPattern === 'scan') {
    request.body = JSON.stringify({"body": {}});
  }

  const result = await syncHttpRequest2(request, 'certificateCores', sortFunction, deterNotification ? false : 'searchCertificateCore',
    messages, state, dispatch);
  devLog('HandleClickSearch end', JSON.stringify(result));

  return result;
} 

// INSERTボタン(署名画面)押下処理
async function HandleClickInsertCertifier(state, dispatch) {
  // 全項目必須ですチェック
  if (state.targetCertificate.no === '' || state.targetCertificate.no === null ||
      state.certifierAddress === '' || state.certifierAddress === null ||
      state.creationTimeClient === '' || state.creationTimeClient === null ||
      state.signature === '' || state.signature === null) {
    dispatch({ type: 'setNotification', key: 'certifier',  value: words.allFieldsMustBeFilledIn[state.language] });
    return;
  }

  let request = {};
  let messages = {};

  // insertCertifier
  request.body = JSON.stringify({
                                  "body": {
                                            "no" : state.targetCertificate.no,
                                            "certifierAddress" : state.certifierAddress,
                                            "creationTimeClient" : state.creationTimeClient,                                            
                                            "signature" : state.signature
                                          }
                                }
                 );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/insert_certifier';

  messages = {
    "success": words.insertDone[state.language],
    "internal server error": words.internalServerError[state.language],
    "no must be number.": words.noMustBeNumber[state.language],
    "no is out of range.": words.noIsOutOfRange[state.language],
    "certifierAddress is too long.": words.certifierAddressIsTooLong[state.language],
    "creationTimeClient must be number.": words.creationTimeClientMustBeNumber[state.language],
    "creationTimeClient is out of range.": words.creationTimeClientIsOutOfRange[state.language],
    "signature is too long.": words.signatureIsTooLong[state.language],
    "requested 'no' is not found": words.requestedNoIsNotFound[state.language],
    "Bad signature.": words.badSignature[state.language],
    "already exists.": words.alreadyExists[state.language],
    "creationTimeClient must be larger than revocationTimeClient.": words.creationTimeClientMustBeLargerThanRevocationTimeClient[state.language],
    "the transaction is not included in blocks": words.theTransactionIsNotIncludedInBlocks[state.language],
    "may not match to prefix": words.mayNotMatchToPrefix[state.language],
    "creationTimeClient must be larger than revocationTimeClient in onchainRevoke.": words.creationTimeClientMustBeLargerThanRevocationTimeClientInOnchainRevoke[state.language],
    "away from current time.": words.awayFromCurrentTime[state.language],
    "creationTimeClient must be larger than last time.": words.creationTimeClientMustBeLargerThanLastTime[state.language],
  };

  // -- GO!
  await syncHttpRequest2(request, 'insertCertifierDummy', undefined, 'certifier', messages, state, dispatch);

  // certifier取得
  request.body = JSON.stringify( { "body": {"no": state.targetCertificate.no} } );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_certifier' ;
  messages = {
//          "success": 'Insert done.'
  };

  const sortFunction = (a, b) => {
    if (a.certifierAddress < b.certifierAddress) {
      return -1;
    }

    if (a.certifierAddress > b.certifierAddress) {
      return 1;
    }

    return 0;
  }

  // -- GO!
  HttpRequest(request, 'certifiers', sortFunction, undefined, messages, state, dispatch);

  // certificateCore取得
  const certificateCores = await HandleClickSearch(state, dispatch, true);

  devLog('ALL', JSON.stringify(certificateCores));
  const targetCertificate = certificateCores.filter( (element) => element.no === state.targetCertificate.no )[0];
  devLog('target', JSON.stringify(targetCertificate));
  dispatch({ type: 'setState', key: 'targetCertificate', value: targetCertificate });
}

// INSERTボタン押下処理
async function HandleClickInsertCertificate(state, dispatch) {
  // 全項目必須ですチェック
  if (state.insertCertificateCertificantAddress === '' || state.insertCertificateCertificantAddress === null || 
      state.insertCertificateCommunity === '' || state.insertCertificateCommunity === null ||
      state.insertCertificateId === '' || state.insertCertificateId === null ||
      state.insertCreationTimeClient === '' || state.insertCreationTimeClient === null ||
      state.insertCertificateSignature === '' || state.insertCertificateSignature === null) {
    dispatch({ type: 'setNotification', key: 'insertCertificate', value: words.allFieldsMustBeFilledIn[state.language] });
    return;
  }

  let request = {};
  request.body = JSON.stringify({
                                  "body": {
                                            "certificantAddress" : state.insertCertificateCertificantAddress,
                                            "community" : state.insertCertificateCommunity,
                                            "id" : state.insertCertificateId,
                                            "creationTimeClient" : state.insertCreationTimeClient,
                                            "signature" : state.insertCertificateSignature
                                          }
                                }
                 );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/insert_certificate';

  const messages = {
    "success": words.insertDone[state.language],
    "internal server error": words.internalServerError[state.language],
    "certificantAddress is too long.": words.certificantAddressIsTooLong[state.language],
    "community is too long.": words.communityIsTooLong[state.language],
    "id is too long.": words.idIsTooLong[state.language],
    "creationTimeClient must be number.": words.creationTimeClientMustBeNumber[state.language],
    "creationTimeClient is out of range.": words.creationTimeClientIsOutOfRange[state.language],
    "signature is too long.": words.signatureIsTooLong[state.language],
    "already exists.": words.alreadyExists[state.language],
    "Bad signature.": words.badSignature[state.language],
    "away from current time.": words.awayFromCurrentTime [state.language],
    "creationTimeClient must be larger than last time.": words.creationTimeClientMustBeLargerThanLastTime[state.language],
  };

  await syncHttpRequest2(request, 'insertCertificateDummy', undefined, 'insertCertificate', messages, state, dispatch);

  await HandleClickSearch(state, dispatch, true);
}

// LOOKボタン押下処理
function handleClickLook(state, dispatch, record) {
/*
  devLog(e.target.value);

  const record = JSON.parse(e.target.value);
*/

  let request = {};
  request.body = JSON.stringify( { "body": {"no": record.no} } );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_certifier' ;

  const messages = {
    "success": words.success[state.language],
    "internal server error": words.internalServerError[state.language],
    "unknown select key": words.unknownSelectKey[state.language],
    "success, but the pair of the 'no' & the 'certifierAddress' does not exist.": words.successButThePairOfTheNoAndTheCertifierAddressDoesNotExist[state.language],
    "success, but the 'no' does not exist.": words.successButTheNoDoesNotExist[state.language],
    "success, but the certifierAddress does not exist.": words.successButTheCertifierAddressDoesNotExist[state.language],
    "success, but no record exists.": words.successButNoRecordExists[state.language],
  };

  const sortFunction = (a, b) => {
    if (a.certifierAddress < b.certifierAddress) {
      return -1;
    }

    if (a.certifierAddress > b.certifierAddress) {
      return 1;
    }

    return 0;
  }

  HttpRequest(request, 'certifiers', sortFunction, 'certifier', messages, state, dispatch);
  dispatch({ type: 'setScreenMode', value: 'certifier' });
  dispatch({ type: 'setState', key: 'targetCertificate', value: record });
}

// revokeボタン押下処理
function handleClickRevoke(state, dispatch, record) {
//  const record = JSON.parse(e.target.value);

  let request = {};
  request.body = JSON.stringify( { "body": { "noAndCertifierAddress": record.no + '_' + record.certifierAddress } } );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_certifier_history' ;

  const messages = {
    "success": words.success[state.language],
    "internal server error": words.internalServerError[state.language],
    "unknown select key": words.unknownSelectKey[state.language],
    "success, but the pair of the 'noAndCertifierAddress' & the 'historyNumber' does not exist.": words.successButThePairOfTheNoAndCertifierAddressAndTheHistoryNumberDoesNotExist[state.language],
    "success, but the 'noAndCertifierAddress' does not exist.": words.successButNoHistory[state.language],
    "success, but no record exists.": words.successButNoRecordExists[state.language],
  };

  const sortFunction = (a, b) => {
    if (a.historyNumber < b.historyNumber) {
      return -1;
    }

    if (a.historyNumber > b.historyNumber) {
      return 1;
    }

    return 0;
  }

  HttpRequest(request, 'certifierHistories', sortFunction, 'updateCertifier', messages, state, dispatch);

  dispatch({ type: 'setScreenMode', value: 'updateCertifier' });
  dispatch({ type: 'setState', key: 'targetSignature', value: record });
}

// revoke(sign)ボタン押下処理
async function handleClickRevokeSign(state, dispatch) {
  // 全項目必須ですチェック
  if (state.targetSignature.no === '' || state.targetSignature.no === null || 
      state.revocationTimeClient === '' || state.revocationTimeClient === null ||
      state.targetSignature.certifierAddress === '' || state.targetSignature.certifierAddress === null ||
      state.signatureForRevoke === '' || state.signatureForRevoke === null) {
    dispatch({ type: 'setNotification', key: 'updateCertifier', value: words.timeAndSignatureFieldsMustBeFilledIn[state.language] });
    return;
  }

  let request = {};
  let messages = {};

  // revoke
  request.body = JSON.stringify( { "body": {
                                     "no": state.targetSignature.no,
                                     "revocationTimeClient": state.revocationTimeClient,
                                     "certifierAddress": state.targetSignature.certifierAddress,
                                     "signatureOfRevocation": state.signatureForRevoke
                                   }
                                 }
                 );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/revoke';

  messages = {
    "success": words.success[state.language],
    "internal server error": words.internalServerError[state.language],
    "no must be number.": words.noMustBeNumber[state.language],
    "no is out of range.": words.noIsOutOfRange[state.language],
    "certifierAddress is too long.": words.certifierAddressIsTooLong[state.language],
    "revocationTimeClient must be number.": words.revocationTimeClientMustBeNumber[state.language],
    "revocationTimeClient is out of range.": words.revocationTimeClientIsOutOfRange[state.language],
    "signatureOfRevocation is too long.": words.signatureOfRevocationIsTooLong[state.language],
    "requested 'no' is not found": words.requestedNoIsNotFound[state.language],
    "Bad signature.": words.badSignature[state.language],
    "target signature not exists.": words.targetSignatureNotExists[state.language],
    "already revoked.": words.alreadyRevoked[state.language],
    "revocationTimeClient must be larger than creationTimeClient.": words.revocationTimeClientMustBeLargerThanCreationTimeClient[state.language],
    "away from current time.": words.awayFromCurrentTime[state.language],
    "revocationTimeClient must be larger than last time.": words.revocationTimeClientMustBeLargerThanLastTime[state.language],
  };

  // -- GO!
  await syncHttpRequest2(request, 'revokeDummy', undefined, 'updateCertifier', messages, state, dispatch);

/*
  // certifierHistory取得
  request.body = JSON.stringify( { "body": { "noAndCertifierAddress": state.targetSignature.no + '_' + state.targetSignature.certifierAddress } } );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_certifier_history' ;

  messages = {
  };

  const sortFunction = (a, b) => {
    if (a.historyNumber < b.historyNumber) {
      return -1;
    }

    if (a.historyNumber > b.historyNumber) {
      return 1;
    }

    return 0;
  }

  // -- GO!
  HttpRequest(request, 'certifierHistories', sortFunction, 'updateCertifier', messages, state, dispatch);
*/

  // certifier取得
  request.body = JSON.stringify( { "body": {"no": state.targetSignature.no} } );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_certifier' ;
  messages = {
//          "success": 'Insert done.'
  };

  const sortFunction = (a, b) => {
    if (a.certifierAddress < b.certifierAddress) {
      return -1;
    }

    if (a.certifierAddress > b.certifierAddress) {
      return 1;
    }

    return 0;
  }

  // -- GO!
  const certifiers = await syncHttpRequest2(request, 'certifiers', sortFunction, false, messages, state, dispatch);

  const targetSignature = certifiers.filter( (element) => element.certifierAddress === state.targetSignature.certifierAddress )[0];
  dispatch({ type: 'setState', key: 'targetSignature', value: targetSignature });

  // certificateCore取得
  const certificateCores = await HandleClickSearch(state, dispatch, true);

  const targetCertificate = certificateCores.filter( (element) => element.no === state.targetCertificate.no )[0];
  dispatch({ type: 'setState', key: 'targetCertificate', value: targetCertificate });
}

// onchain revokeボタン押下処理
async function handleClickOnchainRevoke(state, dispatch) {
  // 必須項目チェック
  if (state.revocationTimeClient === '' || state.revocationTimeClient === null || 
      state.signatureForRevoke === '' || state.signatureForRevoke === null) {
    dispatch({ type: 'setNotification', key: 'updateCertifier', value: words.timeAndSignatureFieldsMustBeFilledIn[state.language] });
    return;
  }

  let myAddress;
  let txHash;

  await window.mpurse.getAddress().then( (result) => {
    myAddress = result;
  } );

//  devLog('myAddress', myAddress);
//  devLog('signature of revocation', state.signatureForRevoke);

//  if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
    console.log('myAddress', myAddress);
    console.log('signature of revocation', state.signatureForRevoke);
//  }

//  console.log('dummy');

  let request = {};
  let response;
  let msg;

  request.url = 'https://monapa.electrum-mona.org/_api';
//  request.url = 'https://wallet.monaparty.me/_api';
//  request.url = 'https://counterblock.api.monaparty.me/';
  const messages = {
         "fulfilled": 'success'
  };
  const text = `@monatrust${process.env.REACT_APP_ENVIRONMENT === 'dev' ? '_dev ' : ' '}{\\"type\\":\\"revoke\\",\\"version\\":\\"1\\",\\"body\\":{\\"certificantAddress\\":\\"${state.targetCertificate.certificantAddress}\\",\\"community\\":\\"${state.targetCertificate.community}\\",\\"id\\":\\"${state.targetCertificate.id}\\",\\"revocationTimeClient\\":${state.revocationTimeClient},\\"certifierAddress\\":\\"${state.targetSignature.certifierAddress}\\",\\"signatureOfRevocation\\":\\"${state.signatureForRevoke}\\"}}`;
  devLog('text', text);
  request.body = `{"jsonrpc":"2.0","id":0,"method":"proxy_to_counterpartyd","params":{"method":"create_broadcast","params":{"source":"${myAddress}","fee_fraction":0,
                   "text":"${text}","timestamp":${Math.floor(state.revocationTimeClient /1000)},"value":-1}}}`;
  response = await syncHttpRequest(request);
  devLog('response', JSON.stringify(response));

  if (response.status === 'rejected') {
    dispatch({ type: 'setNotification', key: 'updateCertifier', value: words.somehowFailed[state.language] });
    return 'rejected';
  }
  else if (response.body.error !== undefined) {
    if ( msg = response.body.error.data.message.match(/feed timestamps not monotonically increasing/) ) {
      dispatch({ type: 'setNotification', key: 'updateCertifier', value: words.feedTimestampsNotMonotonicallyIncreasing[state.language] });
      return 'rejected';
    }
    else {
      dispatch({ type: 'setNotification', key: 'updateCertifier', value: response.body.error.data.message });
      return 'rejected';
    }
  }

  window.mpurse.sendRawTransaction(response.body.result)
    .then( (result) => {
      devLog('txid', result);
      dispatch({ type: 'setState', key: 'onchainRevokeTXID', value: result });
      dispatch({ type: 'setNotification', key: 'updateCertifier', value: words.success[state.language] });
    })
    .catch( (error) => {
      if ( msg = error.match(/User Cancelled/) ) {
        devLog('sendRawTransaction', error);
        dispatch({ type: 'setNotification', key: 'updateCertifier', value: words.userCancelled[state.language] });
      }
      else {
        devLog('sendRawTransaction', error);
        dispatch({ type: 'setNotification', key: 'updateCertifier', value: words.somehowFailed[state.language] });
      }
    });
}

// SET TXIDボタン押下処理
async function HandleClickSetTXID(state, dispatch) {
  // 必須項目チェック
  if (state.targetSignature.no === '' || state.targetSignature.no === null || 
      state.targetSignature.certifierAddress === '' || state.targetSignature.certifierAddress === null ||
      state.onchainRevokeTXID === '' || state.onchainRevokeTXID === null) {
    dispatch({ type: 'setNotification', key: 'updateCertifier', value: words.txidFieldMustBeFilledIn[state.language] });
    return;
  }

  let request = {};
  let messages = {};

  // setTXID
  request.body = JSON.stringify( { "body": {
                                     "no": state.targetSignature.no,
                                     "certifierAddress": state.targetSignature.certifierAddress,
                                     "onchainRevokeTXID": state.onchainRevokeTXID
                                   }
                                 }
                 );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/set_txid';
  messages = {
    "success": words.success[state.language],
    "internal server error": words.internalServerError[state.language],
    "no must be number.": words.noMustBeNumber[state.language],
    "no is out of range.": words.noIsOutOfRange[state.language],
    "certifierAddress is too long.": words.certifierAddressIsTooLong[state.language],
    "onchainRevokeTXID is too long.": words.onchainRevokeTxidIsTooLong[state.language],
    "requested pair of the 'no' and the 'certifierAddress' is not found": words.requestedPairOfTheNoAndTheCertifierAddressIsNotFound[state.language],
    "not revoked yet": words.notRevokedYet[state.language],
    "already set TXID": words.alreadySetTxid[state.language],
    "the transaction is not included in blocks": words.theTransactionIsNotIncludedInBlocks[state.language],
    "may not match to prefix": words.mayNotMatchToPrefix[state.language],
    "type must be 'revoke'": words.typeMustBeRevoke[state.language],
    "version must be '1'": words.versionMustBe1[state.language],
    "requested 'no' is not found": words.requestedNoIsNotFound[state.language],
    "'certificantAddress' does not match": words.certificantAddressDoesNotMatch[state.language],
    "'community' does not match": words.communityDoesNotMatch[state.language],
    "'id' does not match": words.idDoesNotMatch[state.language],
    "'certifierAddress' does not match": words.certifierAddressDoesNotMatch[state.language],
    "Bad signature.": words.badSignature[state.language],
  };

  // -- GO!
  await syncHttpRequest2(request, 'setTXIDDummy', undefined, 'updateCertifier', messages, state, dispatch);

  // certifier取得
  request.body = JSON.stringify( { "body": {"no": state.targetSignature.no} } );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_certifier' ;
  messages = {
  }

  const sortFunction = (a, b) => {
    if (a.certifierAddress < b.certifierAddress) {
      return -1;
    }

    if (a.certifierAddress > b.certifierAddress) {
      return 1;
    }

    return 0;
  }

  // -- GO!
  const certifiers = await syncHttpRequest2(request, 'certifiers', sortFunction, false, messages, state, dispatch);

  const targetSignature = certifiers.filter( (element) => element.certifierAddress === state.targetSignature.certifierAddress )[0];
  dispatch({ type: 'setState', key: 'targetSignature', value: targetSignature });

  // certificateCore取得 ※いらないかも
  const certificateCores = await HandleClickSearch(state, dispatch, true);

  const targetCertificate = certificateCores.filter( (element) => element.no === state.targetCertificate.no )[0];
  dispatch({ type: 'setState', key: 'targetCertificate', value: targetCertificate });
}

// verifyボタン押下処理
function handleClickVerifySignature(state, dispatch) {
  let request = {};
  request.body = JSON.stringify( { "body": {
                                     "message": state.messageToVerify,
                                     "address": state.addressForVerify,
                                     "signature": state.signatureToVerify
                                   }
                                 }
                 );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/verify';

  const messages = {
    "verified": words.verified[state.language],
    "not verified": words.notVerified[state.language],
  };

  HttpRequest(request, 'isVerified', undefined, 'verifySignature', messages, state, dispatch);
}

// clear searchボタン押下処理
function handleClickClearSearch(state, dispatch) {
  dispatch({ type: 'setState', key: 'searchNo', value: ''});
  dispatch({ type: 'setState', key: 'searchId', value: ''});
  dispatch({ type: 'setState', key: 'searchCommunity', value: ''});
  dispatch({ type: 'setState', key: 'searchCertificantAddress', value: ''});
  dispatch({ type: 'setState', key: 'searchCertifierAddress', value: ''});
}

// clear signボタン押下処理
function handleClickClearSign(state, dispatch) {
  dispatch({ type: 'setState', key: 'certifierAddress', value: ''});
  dispatch({ type: 'setState', key: 'creationTimeClient', value: ''});
  dispatch({ type: 'setState', key: 'signature', value: ''});
}

// clear revoke signatureボタン押下処理
function handleClickClearRevokeSignature(state, dispatch) {
  dispatch({ type: 'setState', key: 'revocationTimeClient', value: ''});
  dispatch({ type: 'setState', key: 'signatureForRevoke', value: ''});
  dispatch({ type: 'setState', key: 'onchainRevokeTXID', value: ''});
}

// clear certificateボタン押下処理
function handleClickClearCertificate(state, dispatch) {
  dispatch({ type: 'setState', key: 'insertCertificateCertificantAddress', value: ''});
  dispatch({ type: 'setState', key: 'insertCertificateCommunity', value: ''});
  dispatch({ type: 'setState', key: 'insertCertificateId', value: ''});
  dispatch({ type: 'setState', key: 'insertCreationTimeClient', value: ''});
  dispatch({ type: 'setState', key: 'insertCertificateSignature', value: ''});
}

// clear messageボタン押下処理
function handleClickClearMessage(state, dispatch) {
  dispatch({ type: 'setState', key: 'messageToSign', value: ''});
  dispatch({ type: 'setState', key: 'signatureOfMessage', value: ''});
}

// clear verify signatureボタン押下処理
function handleClickClearVerifySignature(state, dispatch) {
  dispatch({ type: 'setState', key: 'messageToVerify', value: ''});
  dispatch({ type: 'setState', key: 'addressForVerify', value: ''});
  dispatch({ type: 'setState', key: 'signatureToVerify', value: ''});
}

// clear tree markingボタン押下処理
function handleClickClearTreeMarking(state, dispatch) {
  dispatch({ type: 'setState', key: 'addressTree', value: Array(state.treeSteps + 1).fill([]) });
  dispatch({ type: 'setNotification', key: 'setting', value: words.cleared[state.language] });  
}

// clear address to markボタン押下処理
function handleClickClearAddressToMark(state, dispatch) {
  dispatch({ type: 'setState', key: 'addressToMarkString', value: ''});
  dispatch({ type: 'setState', key: 'addressToMark', value: []});
  dispatch({ type: 'setNotification', key: 'setting', value: words.cleared[state.language] });  
}

// clear token owner markingボタン押下処理
function handleClickClearTokenOwnerMarking(state, dispatch) {
  dispatch({ type: 'setState', key: 'addressOfOwner', value: []});
  dispatch({ type: 'setNotification', key: 'setting', value: words.cleared[state.language] });  
}

// clear attach imageボタン押下処理
function handleClickClearAttachImage(dispatch) {
  dispatch({ type: 'setStateMultiLayers', keys: ['image', 'type'], value: 'MonaCharaT'});
  dispatch({ type: 'setStateMultiLayers', keys: ['image', 'id'], value: ''});
  dispatch({ type: 'setStateMultiLayers', keys: ['image', 'registrationTimeClient'], value: ''});
  dispatch({ type: 'setStateMultiLayers', keys: ['image', 'signature'], value: ''});
}

// 特定アドレス設定
function handleClickSetAddressToMark(state, dispatch) {
  dispatch({ type: 'setState', key: 'addressToMark', value: splitIntoLines(state.addressToMarkString) }); 
  dispatch({ type: 'setNotification', key: 'setting', value: words.success[state.language] });  
}

// 行分割
function splitIntoLines(string) {
  const chomped = string.match(/[^\r\n].*[^\r\n]|[^\r\n]/s);
  return chomped ? chomped[0].split(/[\r\n]+/) : [];
}

// TREE MARKING 発動
async function handleClickTreeMarking(state, dispatch) {
  const maxStep = state.treeSteps;
  let addressTree = [];
  await window.mpurse.getAddress().then( (address) => {
    addressTree[0] = [address];
    dispatch({ type: 'setAdressTree', index: 0, value: [address] });
  } );
  let request = {};
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/select_certificate_core';
  const messages = {
    "success": words.success[state.language],
    "internal server error": words.internalServerError[state.language],
    "unknown select key": words.unknownSelectKey[state.language],
  };

  for (let step = 1; step <= maxStep; step++) {
    addressTree[step] = [];
    devLog('pre', addressTree[step - 1]);

    for (let address of addressTree[step - 1]) {
      devLog(address);
      request.body = JSON.stringify( {"body": {"certifierAddress" : address, "excludeRevoked" : true}} );

      const method = 'POST';
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };

      addressTree[step] = addressTree[step].concat(
        await fetch(request.url, { method: method, header: headers, body: request.body })
        .then( response => response.json() )
        .then( json => {
                 const applicationMessage = json.applicationMessage;
                 dispatch({ type: 'setNotification', key: 'setting',
                            value: (messages[applicationMessage] ? messages[applicationMessage] : applicationMessage) });  

                 if (json.applicationStatus === '200') {
                   devLog(json.body);
                   return JSON.parse(json.body).map( record => record.certificantAddress );
                 }
                 else {
                   return [];
                 }
               }
        )
      );

      devLog('post', addressTree[step]);
    }

    addressTree[step] = [ ...new Set(addressTree[step]) ];

    for (let stap = 0; stap <= step - 1; stap++) {
      addressTree[step] = addressTree[step].filter( address => !addressTree[stap].includes(address) );
    }
    devLog('filtered', addressTree[step]);

    dispatch({ type: 'setAdressTree', index: step, value: addressTree[step] });
  }
}

// TOKEN OWNER MARKING 発動
async function handleClickTokenOwnerMarking(state, dispatch) {
  let myAddress;

  await window.mpurse.getAddress().then( (result) => {
    myAddress = result;
  } );
  devLog('myAddress', myAddress);

  let request = {};
  let response;
  request.url = 'https://monapa.electrum-mona.org/_api';
//  request.url = 'https://wallet.monaparty.me/_api';
//  request.url = 'https://counterblock.api.monaparty.me/';
  const messages = {
         "fulfilled": words.success[state.language]
  };
  request.body = `{"jsonrpc":"2.0","id":0,"method":"get_normalized_balances","params":{"addresses": ["${myAddress}"]}}`
  response = await syncHttpRequest(request);
  devLog('response', JSON.stringify(response));

  if (response.status === 'rejected') {
    dispatch({ type: 'setNotification', key: 'setting', value: words.somehowFailed[state.language] });  
    return 'rejected'
  }

  request.body = `{"jsonrpc":"2.0","id":0,"method":"get_assets_info","params":{"assetsList": ${JSON.stringify(response.body.result.map( dict => dict.asset ))}}}`
  devLog('request.body', request.body);
  response = await syncHttpRequest(request);
  devLog('response2', JSON.stringify(response)); 

  if (response.status === 'rejected') {
    dispatch({ type: 'setNotification', key: 'setting', value: words.somehowFailed[state.language] });  
    return 'rejected'
  }

  dispatch({ type: 'setState', key: 'addressOfOwner', value: response.body.result.map( dict => dict.owner ) });
//  dispatch({ type: 'setState', key: 'addressOfIssuer', value: response.body.result.map( dict => dict.issuer ) });

  dispatch({ type: 'setNotification', key: 'setting', value: (messages[response.status] ? messages[response.status] : response.status) });  

  return 'fulfilled';
}

// イメージ登録ボタン押下処理
async function handleClickRegisterImage(state, dispatch) {
  // 必須項目チェック
  if (state.image.type === 'detach') {
    if (state.targetCertificate.no === '' || state.targetCertificate.no === null ||
        state.image.registrationTimeClient === '' || state.image.registrationTimeClient === null ||
        state.image.signature === '' || state.image.signature === null) {
      dispatch({ type: 'setNotification', key: 'certifier',  value: words.allFieldsMustBeFilledInExceptForId[state.language] });
      return;
    }
  }
  else {
    if (state.targetCertificate.no === '' || state.targetCertificate.no === null ||
        state.image.type === '' || state.image.type === null ||
        state.image.id === '' || state.image.id === null ||
        state.image.registrationTimeClient === '' || state.image.registrationTimeClient === null ||
        state.image.signature === '' || state.image.signature === null) {
      dispatch({ type: 'setNotification', key: 'certifier',  value: words.allFieldsMustBeFilledIn[state.language] });
      return;
    }
  }

  let request = {};
  request.body = JSON.stringify( { "body": {
                                     "action" : state.image.type === 'detach' ? 'detach' : 'attach',
                                     "no" : state.targetCertificate.no,
                                     "image": state.image,
                                   }
                                 }
                 );
  request.url = 'https://' + process.env.REACT_APP_DOMAIN_API + '/attach_image';

  const messages = {
    "success": words.insertDone[state.language],
    "internal server error": words.internalServerError[state.language],
    "unknown action": words.unknownAction[state.language],
    "no must be number.": words.noMustBeNumber[state.language],
    "no is out of range.": words.noIsOutOfRange[state.language],
    "unknown image type.": words.unknownImageType[state.language],
    "image id is too long.": words.imageIdIsTooLong[state.language],
    "registrationTimeClient must be number.": words.registrationTimeClientMustBeNumber[state.language],
    "registrationTimeClient is out of range.": words.registrationTimeClientIsOutOfRange[state.language],
    "away from current time.": words.awayFromCurrentTime[state.language],
    "signature is too long.": words.signatureIsTooLong[state.language],
    "requested 'no' is not found": words.requestedNoIsNotFound[state.language],
    "not changed.": words.notChanged[state.language],
    "no image attached.": words.noImageAttached[state.language],
    "somehow failed.": words.somehowFailed[state.language],
    "token does not exist.": words.tokenDoesNotExist[state.language],
    "you don't have the token.": words.youDontHaveTheToken[state.language],
    "Bad signature.": words.badSignature[state.language],
    "registrationTimeClient must be larger than last time.": words.registrationTimeClientMustBeLargerThanLastTime[state.language],
  };

  const result = await syncHttpRequestBless2(request, undefined, undefined, 'certifier', messages, state, dispatch);

  if (result.status === 'fulfilled') {
    dispatch({ type: 'setState', key: 'attachImagePopup', value: false });
  }
  else {
    return 'rejected';
  }

  // certificateCore取得
  const certificateCores = await HandleClickSearch(state, dispatch, true);
  const targetCertificate = certificateCores.filter( (element) => element.no === state.targetCertificate.no )[0];
  dispatch({ type: 'setState', key: 'targetCertificate', value: targetCertificate });

  return 'fulfilled';
}

// 保有トークンチェック＆初期設定
function checkTokensAndSet(notification, state, dispatch) {
  window.mpurse.getAddress()
    .then( async (result) => {
      let myAddress = result;
      devLog('myAddress', myAddress);

      let request = {};
      let response;

      request.url = 'https://monapa.electrum-mona.org/_api';
//      request.url = 'https://wallet.monaparty.me/_api';
//      request.url = 'https://counterblock.api.monaparty.me/';
      request.body = `{"jsonrpc":"2.0","id":0,"method":"get_normalized_balances","params":{"addresses": ["${myAddress}"]}}`
      const messages = {
         "fulfilled": 'success'
      };

      response = await syncHttpRequest(request);
      devLog('response', JSON.stringify(response));

      if (response.status === 'rejected') {
        if (notification) {
          dispatch({ type: 'setNotification', key: 'setting', value: words.somehowFailed[state.language] });  
        }

        return;
      }

      // 各種設定
      // デフォルト設定
      dispatch({ type: 'setState', key: 'language', value: 'japanese' });
 
      // 保有トークンによる設定
      response.body.result.forEach(token => {
        if (token.asset_longname === 'MONATRUST.0003') {
          dispatch({ type: 'setState', key: 'language', value: 'japanese' });
        }
      });

      if (notification) {
        dispatch({ type: 'setNotification', key: 'setting', value: words.success[state.language] });  
      }
    });
}

// HTTPリクエスト
function HttpRequest(request, setResultKey, sortFunction, setNotificationKey, messages, state, dispatch) {
  const method = 'POST';
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  fetch(request.url, { method: method, headers: headers, body: request.body })
  .then( response => response.json() )
  .then( json => {
           const applicationMessage = json.applicationMessage;

           devLog(applicationMessage, messages[applicationMessage], setNotificationKey);

           if (setNotificationKey !== undefined) {
             dispatch({ type: 'setNotification', key: setNotificationKey,
                        value: (messages[applicationMessage] ? messages[applicationMessage] : applicationMessage) });  
           }

           if (json.applicationStatus.substring(0,1) === '2') {
             devLog(setResultKey);
             devLog(json.body);

             let body = JSON.parse(json.body);

             if (sortFunction !== undefined) {
               body.sort(sortFunction);
             }

             dispatch({ type: 'setState', key: setResultKey, value: body });
           }
           else {
           }
         }
  );
}

// const httpRequest = HttpRequest;

// HTTPリクエスト改
function httpRequest(request, setResultKey, sortFunction, setNotificationKey, messages, state, dispatch) {
  const method = 'POST';
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  fetch(request.url, { method: method, headers: headers, body: request.body })
  .then( response => response.json() )
  .then( json => {
           const applicationMessage = json.applicationMessage;

           devLog(applicationMessage, messages[applicationMessage], setNotificationKey);

           if (setNotificationKey !== undefined) {
             dispatch({ type: 'setNotification', key: setNotificationKey,
                        value: (messages[applicationMessage] ? messages[applicationMessage] : applicationMessage) });  
           }

           if (json.applicationStatus.substring(0,1) === '2') {
             let body = JSON.parse(json.body);

             if (setResultKey !== undefined) {
               devLog(setResultKey);
               devLog(JSON.stringify(body));

               if (sortFunction !== undefined) {
                 body.sort(sortFunction);
               }

               dispatch({ type: 'setState', key: setResultKey, value: body });
             }

             return { status: 'fulfilled', body: body } ;
           }
           else {
             return { status: 'rejected' };
           }
         }
  );
}

// HTTPリクエスト（同期バージョン2）
async function syncHttpRequest2(request, setResultKey, sortFunction, setNotificationKey, messages, state, dispatch) {
  const method = 'POST';
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  const body = await fetch(request.url, { method: method, headers: headers, body: request.body })
  .then( response => response.json() )
  .then( async json => {
           const applicationMessage = json.applicationMessage;

           devLog(applicationMessage, messages[applicationMessage], 'setNotificationKey', setNotificationKey);

           if (setNotificationKey !== false) {
             devLog('inner', setNotificationKey);
             dispatch({ type: 'setNotification', key: setNotificationKey,
                        value: (messages[applicationMessage] ? messages[applicationMessage] : applicationMessage) });  
           }

           if (json.applicationStatus.substring(0,1) === '2') {
             devLog(setResultKey);
             devLog(json.body);

             let body = JSON.parse(json.body);

             if (sortFunction !== undefined) {
               body.sort(sortFunction);
             }

             dispatch({ type: 'setState', key: setResultKey, value: body });

             return body;
           }
           else {
           }
         }
  );

  return body;
}

// HTTPリクエスト（同期バージョンBLESS2）
async function syncHttpRequestBless2(request, setResultKey, sortFunction, setNotificationKey, messages, state, dispatch) {
  const method = 'POST';
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  const result = await fetch(request.url, { method: method, headers: headers, body: request.body })
  .then( response => response.json() )
  .then( async json => {
           const applicationMessage = json.applicationMessage;

           devLog(applicationMessage, messages[applicationMessage], 'setNotificationKey', setNotificationKey);

           if (setNotificationKey !== undefined) {
             devLog('inner', setNotificationKey);
             dispatch({ type: 'setNotification', key: setNotificationKey,
                        value: (messages[applicationMessage] ? messages[applicationMessage] : applicationMessage) });  
           }

           if (json.applicationStatus.substring(0,1) === '2') {
             let body = json.body;

             if (setResultKey !== undefined) {
               devLog(setResultKey);
               devLog(JSON.stringify(body));

               if (sortFunction !== undefined) {
                 body.sort(sortFunction);
               }

               dispatch({ type: 'setState', key: setResultKey, value: body });
             }

             return { status: 'fulfilled', body: body } ;
           }
           else {
             return { status: 'rejected' };
           }
         }
  )
  .catch( error => {
           return { status: 'rejected' };
          }
  );

  return result;
}

// HTTPリクエスト（同期バージョン）
async function syncHttpRequest(request) {
  const method = 'POST';
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  return await fetch(request.url, { method: method, header: headers, body: request.body })
  .then( response => response.json() )
  .then( json => {
    devLog('syncHttpRequest fulfilled', JSON.stringify(json));
    return { status: 'fulfilled', body: json };
  })
  .catch( error => {
    devLog('syncHttpRequest rejected', JSON.stringify(error));
    return { status: 'rejected', body: error };
  });
}

// mpurse(アドレス取得)
function GetAddress(setFunction) {
  window.mpurse.getAddress().then( (result) => { setFunction(result) } );
}

// mpurse(署名)
function Sign(message, setFunction) {
  devLog('message', message);

  window.mpurse.signMessage(message)
    .then( (result) => {
      devLog('signature', result);
      setFunction(result);
    });
}

// クリップボードコピー
function copyClipboard(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  }
}

// クリップボードペースト
function pasteClipboard(dispatch) {
  if (navigator.clipboard) {
    navigator.clipboard.readText().then( (text) => {
      devLog('text\n' ,text);

      const message = text.match(/(--message begin--[\r\n]+)(.*)([\r\n]+--message end--)/s);
      devLog('message[2]\n' ,message[2]);
      message[2] = message[2].replace(/[\r\n]$/gm, '');
      devLog('message[2]\n' ,message[2]);
      dispatch( {type: 'setState', key: 'messageToVerify', value: message[2]} );

      const text2 = text.replace(/^--message begin--[\r\n]+.*[\r\n]+--message end--[\r\n]*/s, '');
      devLog('text2\n',text2);
      const address = text2.match(/(--address--[\r\n]+)([^\r\n]*)/);
      // const address = text2.match(/(?<=^--address--[\r\n]+)[^\r\n]*/m);
      devLog('address[2]\n',address[2]);
      dispatch( {type: 'setState', key: 'addressForVerify', value: address[2]} );

      const text3 = text2.replace(/^--address--[\r\n]+[^\r\n]*[\r\n]*/, '');
      devLog('text3\n',text3);
      const signature = text3.match(/(--signature--[\r\n]+)([^\r\n]*)/);
      devLog("signature[2]\n",signature[2]);
      dispatch( {type: 'setState', key: 'signatureToVerify', value: signature[2]} );
    });
  }
}

// devLog
function devLog(...words) {
  if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
    console.log(words.join(' '));
  }
  return 1;
}

// LOCAL TIME
function localTime(epoch, format) {
  const epochNum = parseInt(epoch, 10);
  let time;

  if (Number.isNaN(epochNum) || epochNum === '' || epochNum === undefined) {
    return '';
  }

  time = new Date(epoch);

  if (format === 'list') {
    return `${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()} ${time.getHours()}:${time.getMinutes()}`;
  }
  else {
    return `${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()} ${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}.${time.getMilliseconds()}`;
  }
}

// MESSAGE TO SIGN
function messageToSignFunc(state, condition) {
  if (condition.action === 'attachImage') {
    if (state.image.type === 'detach') {
      return 'monatrust:1:detachImage,' + state.targetCertificate.certificantAddress + ',' + state.targetCertificate.community + ',' + state.targetCertificate.id + ',' 
             + state.image.registrationTimeClient;
    }
    else {
      return 'monatrust:1:attachImage,' + state.targetCertificate.certificantAddress + ',' + state.targetCertificate.community + ',' + state.targetCertificate.id + ',' + state.image.type + ','
             + state.image.id + ',' + state.image.registrationTimeClient;
    }
  }
  else if (false) {
  }
}

// reducer
function reducer(state, action) {
  let newState = { ...state };
  let number;

  switch (action.type) {
    case 'setState':
      newState[action.key] = action.value;
      return newState;
    case 'setStateMultiLayers':
      action.keys.concat(action.value).reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc;
        }
        if (idx === src.length - 2) {
          return acc[cur] = src[idx + 1];
        }
        else {
          return acc[cur];
        }
      }, newState );
      return newState;
    case 'setStateNum':
      number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;
    case 'setStateMultiLayersNum':
      number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        number = ''
      }

      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc[cur] = number;
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;
    case 'setNotification':
      newState.notification[action.key] = action.value;
      newState.notificationFade[action.key] = true;
      return newState;
    case 'unsetNotification':
      newState.notification[action.key] = '';
      newState.notificationFade[action.key] = false;
      return newState;
    case 'setScreenMode':
      newState.notification[state.screenMode] = '';
      newState.notificationFade[state.screenMode] = false;
      newState.screenMode = action.value;
      return newState;
    case 'setAdressTree':
      newState.addressTree[action.index] = action.value;
      return newState;
    case 'toggle':
      newState[action.key] = state[action.key] ? false : true;
      return newState;
    case 'setCertifierAddressAndSearch':
      newState.searchPattern = 'certifierAddress';
      newState.searchCertifierAddress = action.certifierAddress;
      newState.autoSearch2.flag = true;
      newState.autoSearch2.deterNotification = action.deterNotification;
      newState.autoSearch2.trigger = !newState.autoSearch2.trigger;
      return newState;
    default:
      return state;
  }
}

export default App;
export { reducer };

